export default {
  type: "Feature",
  properties: {
    name: "Налайх",
    location: [47.98867, 107.4566],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [107.464536185896, 47.9883352925398],
        [107.464617042143, 47.9883335442577],
        [107.464701617985, 47.9883339606438],
        [107.464790821739, 47.9883365443961],
        [107.464886461041, 47.9883413458764],
        [107.465035250277, 47.9883519461854],
        [107.465412046429, 47.9883852237991],
        [107.465585515759, 47.988397901542],
        [107.465845283133, 47.9884160300758],
        [107.46649682307, 47.9884708212714],
        [107.466796262238, 47.9884922269348],
        [107.466960447866, 47.9885009278756],
        [107.467113667162, 47.9885063903577],
        [107.467259029081, 47.9885087267963],
        [107.467398091249, 47.988507955178],
        [107.467685725916, 47.9885032975891],
        [107.467857676291, 47.9884972928159],
        [107.468016034313, 47.9884864667771],
        [107.468157279135, 47.9884703500267],
        [107.468294253977, 47.9884493292732],
        [107.468416233522, 47.9884268606112],
        [107.468527170293, 47.9884022101939],
        [107.468628344922, 47.9883750803457],
        [107.468731249847, 47.9883408818263],
        [107.468841541804, 47.9882965335582],
        [107.468950201491, 47.9882470528593],
        [107.469172000388, 47.9881398923422],
        [107.469288868187, 47.9880824895153],
        [107.46940762816, 47.9880196188104],
        [107.469529524068, 47.9879506291183],
        [107.469656941814, 47.9878741723552],
        [107.469886441606, 47.9877275702712],
        [107.470427566379, 47.9873672622893],
        [107.470575534533, 47.98727356912],
        [107.470712075002, 47.9871914897955],
        [107.470813455577, 47.9871301614278],
        [107.47103954424, 47.9869876017964],
        [107.471144315258, 47.9869252751814],
        [107.471209048459, 47.9868895792907],
        [107.471271031533, 47.9868578997723],
        [107.471331510941, 47.9868295990069],
        [107.471391132395, 47.986804380218],
        [107.471521275986, 47.9867538113394],
        [107.471625726846, 47.9867173168507],
        [107.471722154854, 47.9866887345975],
        [107.471812633846, 47.9866675942341],
        [107.471886229866, 47.9866550226113],
        [107.471969341612, 47.9866448584735],
        [107.472061183977, 47.986636876091],
        [107.472207033328, 47.9866271733055],
        [107.472309543451, 47.9866222225376],
        [107.472424396769, 47.9866201594928],
        [107.472872692621, 47.9866234779911],
        [107.473029609929, 47.9866239204576],
        [107.473377203295, 47.9866291032506],
        [107.473523745125, 47.9866290834654],
        [107.473699142601, 47.9866241165098],
        [107.473779012292, 47.9866193393111],
        [107.473855086843, 47.9866129559232],
        [107.474002527095, 47.9865971890091],
        [107.474136124083, 47.9865797151818],
        [107.474259682838, 47.9865600335188],
        [107.474374653068, 47.9865379021026],
        [107.474474926577, 47.9865153848772],
        [107.474574040859, 47.9864903882209],
        [107.474671288149, 47.9864630910988],
        [107.474765998452, 47.9864336823686],
        [107.474855552941, 47.9864030451645],
        [107.474944499489, 47.9863697423698],
        [107.475032552111, 47.9863338810039],
        [107.475119407735, 47.9862955842739],
        [107.475204778578, 47.9862549771855],
        [107.475288314804, 47.9862122252141],
        [107.475369691758, 47.9861674965328],
        [107.475448573993, 47.9861209719054],
        [107.475517937803, 47.9860766488184],
        [107.475590948364, 47.986026133899],
        [107.475669342266, 47.9859683560548],
        [107.475770462037, 47.9858905341209],
        [107.47591932142, 47.9857783760713],
        [107.475985398208, 47.9857251658838],
        [107.476044989984, 47.9856698683698],
        [107.476090311319, 47.9856175700949],
        [107.476114070508, 47.9855834435211],
        [107.476135734277, 47.9855468168322],
        [107.476155405148, 47.9855075191567],
        [107.476173233308, 47.9854652492219],
        [107.476203733815, 47.9853714292481],
        [107.476231376277, 47.9852526773692],
        [107.476240461228, 47.9851951351474],
        [107.476245492935, 47.9851304720937],
        [107.476246766375, 47.9849117794551],
        [107.476246297828, 47.9847999352688],
        [107.476237985395, 47.9845430322352],
        [107.476239196782, 47.9844223809881],
        [107.476238534881, 47.9842498685367],
        [107.476241177988, 47.9841865472714],
        [107.476251154167, 47.9841189011664],
        [107.476269405908, 47.9840598795598],
        [107.476298210294, 47.9840000422682],
        [107.476337168925, 47.9839373064616],
        [107.47638652282, 47.9838712602505],
        [107.476447226159, 47.9838006194031],
        [107.476538770848, 47.9837038739347],
        [107.476577646741, 47.9836669900396],
        [107.476615172752, 47.9836345901643],
        [107.476653164612, 47.9836052425879],
        [107.476691040459, 47.9835795309706],
        [107.476729113258, 47.983557247569],
        [107.476767568269, 47.9835382844643],
        [107.476807634865, 47.9835222252705],
        [107.476852161198, 47.9835079476337],
        [107.476901534878, 47.9834953238501],
        [107.476956564394, 47.9834841470758],
        [107.47707180442, 47.9834670689501],
        [107.47730191755, 47.9834416136396],
        [107.477479204502, 47.9834227980237],
        [107.477648902975, 47.9834105951229],
        [107.477811157759, 47.9834049941452],
        [107.477966005727, 47.9834059950907],
        [107.478127214599, 47.9834127184222],
        [107.478267119432, 47.9834233205299],
        [107.478393252047, 47.9834383805768],
        [107.478507480336, 47.9834581620646],
        [107.478602358812, 47.9834814536063],
        [107.478704895015, 47.9835143310216],
        [107.478799465023, 47.9835498119743],
        [107.479009552949, 47.9836341423019],
        [107.479104104071, 47.9836687742945],
        [107.479371401469, 47.9837617489056],
        [107.47945077923, 47.9837873705907],
        [107.479522971408, 47.9838087249927],
        [107.479663206292, 47.9838484912149],
        [107.479744318845, 47.9838694211369],
        [107.47982134398, 47.9838857932948],
        [107.479891784278, 47.9838965419919],
        [107.479973994904, 47.9839036385421],
        [107.480064703224, 47.9839063149245],
        [107.480165739357, 47.9839046988428],
        [107.480288191947, 47.9838986212244],
        [107.480390512312, 47.9838913600982],
        [107.480475231147, 47.9838829019744],
        [107.480550944171, 47.9838723844031],
        [107.480619218003, 47.9838595402856],
        [107.480704933286, 47.9838380159118],
        [107.48079346075, 47.9838099750503],
        [107.480884555778, 47.9837754959424],
        [107.480977837957, 47.9837347215802],
        [107.481024471402, 47.9837111350609],
        [107.481070344921, 47.983684120326],
        [107.481115955837, 47.9836533922902],
        [107.481162218761, 47.9836183376162],
        [107.481241922077, 47.9835498695309],
        [107.481419869132, 47.9833835902805],
        [107.481467282289, 47.9833431324797],
        [107.48151221062, 47.9833081074832],
        [107.481690506612, 47.9831778928455],
        [107.481854727314, 47.9830618020605],
        [107.482011069056, 47.9829554644232],
        [107.482161917738, 47.9828572683483],
        [107.48231023393, 47.9827653423467],
        [107.482455953779, 47.9826797826459],
        [107.482599964017, 47.9826000649411],
        [107.4827428528, 47.9825258690736],
        [107.482853714927, 47.9824726714767],
        [107.482980003125, 47.982416735444],
        [107.483110095455, 47.9823624325803],
        [107.483462630596, 47.9822193900129],
        [107.483567048181, 47.9821749131418],
        [107.483659288046, 47.9821335533209],
        [107.483999317215, 47.9819793078988],
        [107.484162402973, 47.9819018627808],
        [107.484317066579, 47.9818215092553],
        [107.484385466316, 47.9817826225701],
        [107.484449026801, 47.9817439706078],
        [107.484573851802, 47.9816622330257],
        [107.484689604442, 47.9815800565744],
        [107.484796023018, 47.9814976274136],
        [107.484892933962, 47.9814150822403],
        [107.484969427597, 47.9813425600112],
        [107.485047831392, 47.9812602828358],
        [107.485129706571, 47.9811669925627],
        [107.485239270976, 47.9810350907969],
        [107.485278668476, 47.9809846541186],
        [107.48531952018, 47.9809273079489],
        [107.485445120396, 47.9807344231552],
        [107.485493289883, 47.9806641474325],
        [107.48554457822, 47.9805967162655],
        [107.48559582159, 47.9805378088728],
        [107.48571742342, 47.9804101564036],
        [107.485809450146, 47.9803229293598],
        [107.485855040378, 47.9802842854915],
        [107.485900200734, 47.9802492775822],
        [107.485945476203, 47.9802174820512],
        [107.485991184246, 47.980188682162],
        [107.48605684195, 47.980152591469],
        [107.486133855393, 47.9801157732244],
        [107.486220975418, 47.9800783776151],
        [107.486363555734, 47.9800209774862],
        [107.486536333485, 47.9799526290106],
        [107.486664793545, 47.9799058615663],
        [107.48678320638, 47.9798681952611],
        [107.486893761838, 47.9798392092122],
        [107.486961843215, 47.9798245808398],
        [107.487033331223, 47.9798114471406],
        [107.4871084435, 47.9797997703432],
        [107.48718751729, 47.9797894964881],
        [107.487358630397, 47.9797729804387],
        [107.487555750997, 47.9797610113616],
        [107.487706419815, 47.9797562359616],
        [107.487855243225, 47.9797560767816],
        [107.488000985557, 47.9797605338216],
        [107.48814265486, 47.9797695774041],
        [107.488275355224, 47.979782997987],
        [107.488417230471, 47.9798024970876],
        [107.488571221385, 47.9798284362334],
        [107.488749482303, 47.9798628478922],
        [107.488865236741, 47.9798887465685],
        [107.488991747072, 47.9799218928811],
        [107.489114447874, 47.9799574673633],
        [107.489426964982, 47.9800522019476],
        [107.48960099459, 47.9800998093588],
        [107.48990961134, 47.9801800450731],
        [107.490049633983, 47.9802141167881],
        [107.490192323117, 47.9802439895685],
        [107.490322253569, 47.9802650903617],
        [107.490480928152, 47.9802835237657],
        [107.49064372253, 47.9802962671591],
        [107.490808776004, 47.9803031748517],
        [107.490974036323, 47.9803041623073],
        [107.491149038997, 47.9802989579306],
        [107.491318810315, 47.9802876606471],
        [107.491481831321, 47.9802703702814],
        [107.491637047112, 47.9802472028462],
        [107.491759712841, 47.9802235938438],
        [107.49188656851, 47.9801943892597],
        [107.492017827261, 47.9801595351345],
        [107.492153962136, 47.9801189118584],
        [107.492249881127, 47.9800871837766],
        [107.492346735414, 47.9800519330503],
        [107.492444680578, 47.980013099425],
        [107.492543942349, 47.9799705965658],
        [107.492644602566, 47.9799243965937],
        [107.492747252084, 47.9798742360072],
        [107.492852404415, 47.9798198710902],
        [107.492960975069, 47.9797608243027],
        [107.49316891991, 47.9796464341357],
        [107.49328216524, 47.9795781225324],
        [107.493333413107, 47.9795432693065],
        [107.493378527597, 47.9795091993901],
        [107.493418217377, 47.9794753758879],
        [107.493452825987, 47.9794415029231],
        [107.493512779291, 47.9793728387855],
        [107.493562924589, 47.979304068528],
        [107.493602174601, 47.9792366949176],
        [107.493630032, 47.9791715875987],
        [107.493642410269, 47.9791317233504],
        [107.49365199974, 47.979091814136],
        [107.493658679904, 47.9790523554819],
        [107.493662391406, 47.9790137233047],
        [107.49366310277, 47.9789763303934],
        [107.493660823888, 47.9789403215387],
        [107.493655567351, 47.9789058999873],
        [107.49364735654, 47.9788732159262],
        [107.493637562024, 47.9788465726113],
        [107.493624154032, 47.9788191226045],
        [107.493607005759, 47.9787906024044],
        [107.493585813235, 47.9787605002969],
        [107.493538955858, 47.9787034554002],
        [107.49342716743, 47.9785800045636],
        [107.493379949425, 47.97852828815],
        [107.493323972923, 47.9784728224628],
        [107.493078833921, 47.9782525641046],
        [107.493024655164, 47.9782008539863],
        [107.492978645848, 47.9781533949633],
        [107.492844397751, 47.9780092345386],
        [107.492770034609, 47.9779239572249],
        [107.492707254736, 47.9778423743261],
        [107.492658851425, 47.9777665605783],
        [107.492616140822, 47.9776846215481],
        [107.492580515079, 47.9776021249382],
        [107.492552422057, 47.9775201022709],
        [107.492532142345, 47.9774393890166],
        [107.492510112552, 47.9773295961839],
        [107.492502109485, 47.9772593960044],
        [107.492501851379, 47.9772267686005],
        [107.492504355991, 47.9771965145076],
        [107.492509660193, 47.9771682290306],
        [107.492517804453, 47.9771417053255],
        [107.49254001501, 47.9770953164957],
        [107.492573411334, 47.9770455920805],
        [107.492618350457, 47.9769916831197],
        [107.492681733775, 47.9769252924683],
        [107.49271849806, 47.9768902198078],
        [107.492759115041, 47.9768552730525],
        [107.492803546047, 47.9768204845777],
        [107.492851738017, 47.9767858948532],
        [107.492903651382, 47.9767515362544],
        [107.492959180022, 47.9767174816265],
        [107.493080607384, 47.9766505630731],
        [107.493125302791, 47.9766289892365],
        [107.493173914744, 47.9766083093261],
        [107.49322694147, 47.9765883066051],
        [107.493285398303, 47.9765685970631],
        [107.493398207461, 47.9765351926451],
        [107.493684065967, 47.976457965163],
        [107.493761813257, 47.9764342221617],
        [107.493829862258, 47.9764107912251],
        [107.494139344155, 47.9762937075886],
        [107.494266003773, 47.9762426189018],
        [107.494381796882, 47.976193384617],
        [107.494490996163, 47.9761441071649],
        [107.494592674412, 47.9760951255896],
        [107.494687746243, 47.9760459938276],
        [107.494776744951, 47.9759964384849],
        [107.49495328007, 47.9758965939527],
        [107.495041411832, 47.9758423000821],
        [107.495082187093, 47.975814055974],
        [107.495117884783, 47.9757865852827],
        [107.495149100251, 47.9757594266563],
        [107.495176112288, 47.975732332781],
        [107.495207726156, 47.9756952852093],
        [107.49523686419, 47.9756555072959],
        [107.495263349224, 47.9756132382604],
        [107.495286983408, 47.9755687937649],
        [107.495307612956, 47.9755224400087],
        [107.495324981563, 47.9754747273768],
        [107.495338901269, 47.9754261639864],
        [107.495349197607, 47.9753773622755],
        [107.495356007274, 47.9753161508198],
        [107.495356069327, 47.9752500596426],
        [107.495349390962, 47.9751787119281],
        [107.495335868755, 47.9751009421548],
        [107.495317629605, 47.9750391038716],
        [107.495287355727, 47.9749718606629],
        [107.495249725395, 47.9749053513009],
        [107.495140328264, 47.9747292217762],
        [107.495112127323, 47.9746758919789],
        [107.495091142542, 47.9746273411789],
        [107.49505237097, 47.9745150068621],
        [107.495019763351, 47.97439958877],
        [107.494993459081, 47.9742815914224],
        [107.494973594856, 47.9741616182641],
        [107.494965230261, 47.9741137941164],
        [107.494938006884, 47.9739875562807],
        [107.494929560451, 47.97391867091],
        [107.494929770892, 47.9738820631068],
        [107.494934133504, 47.9738486928629],
        [107.494942732821, 47.9738179432435],
        [107.494955657877, 47.9737895129757],
        [107.494987905767, 47.9737407121642],
        [107.495030385244, 47.9736919967883],
        [107.495080973908, 47.9736458085073],
        [107.495136939618, 47.9736046483359],
        [107.495159248201, 47.9735916009716],
        [107.495186499457, 47.9735786093654],
        [107.495308857618, 47.973529426342],
        [107.495333544008, 47.9735169122757],
        [107.4953539829, 47.9735041455],
        [107.495391194148, 47.9734757404132],
        [107.49542450054, 47.9734456329097],
        [107.495452683495, 47.9734149318537],
        [107.495475006466, 47.9733844448363],
        [107.495492776171, 47.9733483568412],
        [107.495503927764, 47.9733058899549],
        [107.495508990947, 47.9732602898306],
        [107.495512251889, 47.973170782106],
        [107.495511981193, 47.9731415451462],
        [107.495507868593, 47.9731087252875],
        [107.495481688429, 47.972996101389],
        [107.495474689006, 47.972953392585],
        [107.495474175493, 47.9729108168807],
        [107.495482067943, 47.9728734419558],
        [107.495509934336, 47.9728071313441],
        [107.495526443191, 47.9727772954359],
        [107.495544513269, 47.9727499704348],
        [107.495564004275, 47.9727253487958],
        [107.495584895527, 47.9727034431095],
        [107.495607125868, 47.9726843154289],
        [107.495630652133, 47.9726680008276],
        [107.495655073223, 47.9726543419244],
        [107.495682793027, 47.9726414312571],
        [107.495746961453, 47.9726183744385],
        [107.495820051155, 47.9725999752088],
        [107.495896213839, 47.9725877282411],
        [107.495955658127, 47.9725830328807],
        [107.496017142078, 47.9725823907648],
        [107.496077571123, 47.9725858315709],
        [107.496134213124, 47.9725931961191],
        [107.496189716582, 47.9726062210004],
        [107.496248820926, 47.9726270331112],
        [107.496310402004, 47.9726545469698],
        [107.496409000975, 47.9727042902708],
        [107.496442797497, 47.9727232830531],
        [107.49647782789, 47.972747038645],
        [107.496586525348, 47.972834338534],
        [107.496628668478, 47.9728649541544],
        [107.496674360334, 47.9728915039398],
        [107.496720071974, 47.9729103780116],
        [107.496788922271, 47.9729302961962],
        [107.49685960089, 47.9729452977873],
        [107.496928015915, 47.9729545293281],
        [107.496991787741, 47.9729576814519],
        [107.497025056361, 47.9729566589227],
        [107.497059922178, 47.9729535130942],
        [107.497135095608, 47.9729407831907],
        [107.497218238831, 47.9729195061304],
        [107.497321192319, 47.9728866592919],
        [107.497385363444, 47.9728617849435],
        [107.497453147145, 47.9728291899152],
        [107.497516563738, 47.9727941478317],
        [107.497661297031, 47.9727089775373],
        [107.49772648349, 47.9726694289511],
        [107.497795312204, 47.9726222828921],
        [107.497860081378, 47.9725739973921],
        [107.498020531223, 47.9724495968715],
        [107.498110901397, 47.9723852908485],
        [107.498160773301, 47.9723536095315],
        [107.498209419429, 47.9723257782122],
        [107.498257746298, 47.9723012824783],
        [107.498306243139, 47.9722798786136],
        [107.498434099754, 47.9722293232247],
        [107.498534043212, 47.9721949790151],
        [107.498626248003, 47.972169918507],
        [107.498669876813, 47.9721608362536],
        [107.498712234882, 47.9721539708291],
        [107.498783828111, 47.9721464713826],
        [107.498862418966, 47.9721427850615],
        [107.49894862438, 47.9721428731951],
        [107.499044711544, 47.9721467330853],
        [107.499111194826, 47.9721515705386],
        [107.499177956897, 47.9721585726601],
        [107.499244479749, 47.972167684591],
        [107.499310258861, 47.9721788379831],
        [107.49937476993, 47.9721919420046],
        [107.499437589373, 47.9722069094214],
        [107.49949828282, 47.9722236359121],
        [107.499556473453, 47.9722420180547],
        [107.49963041751, 47.9722693592436],
        [107.499706243848, 47.9723021179485],
        [107.499784112547, 47.9723403616184],
        [107.499864473267, 47.9723843078896],
        [107.499937942482, 47.9724312165275],
        [107.500012838022, 47.9724887596486],
        [107.500078883334, 47.9725463945006],
        [107.50021846531, 47.9726757457891],
        [107.500277224315, 47.9727265278071],
        [107.500336843071, 47.97277994304],
        [107.500460121238, 47.9729017732982],
        [107.500512327782, 47.9729479202104],
        [107.500548074934, 47.9729754601494],
        [107.500583639523, 47.9729993002775],
        [107.500619744606, 47.9730199199334],
        [107.500656776889, 47.9730375412496],
        [107.500710056324, 47.9730596115119],
        [107.500754640215, 47.9730759872671],
        [107.50079572844, 47.9730885741784],
        [107.500834015278, 47.9730975359226],
        [107.500867824391, 47.973102971425],
        [107.500903969043, 47.9731065983909],
        [107.500942406967, 47.9731084114241],
        [107.500983080605, 47.9731084105248],
        [107.501070906597, 47.9731029552373],
        [107.501166496437, 47.9730902918835],
        [107.501247685432, 47.9730736085602],
        [107.501328998535, 47.9730502576633],
        [107.501407106453, 47.9730211933734],
        [107.501478521617, 47.9729877089157],
        [107.501551998026, 47.9729446763558],
        [107.501616758207, 47.9728977200538],
        [107.501644590426, 47.9728736883701],
        [107.501669078965, 47.9728495613582],
        [107.50169001788, 47.9728255476609],
        [107.501707271374, 47.9728017983643],
        [107.501717227768, 47.9727841599611],
        [107.501725021293, 47.9727650691527],
        [107.501734485758, 47.9727215185833],
        [107.501736690896, 47.9726780111813],
        [107.501734358054, 47.9725690439263],
        [107.501736453475, 47.9725396603771],
        [107.501740894327, 47.9725137131374],
        [107.501762514029, 47.9724307722624],
        [107.501788414504, 47.9723510833359],
        [107.501818488732, 47.9722749638186],
        [107.50185265038, 47.972202638541],
        [107.501876966249, 47.9721586149282],
        [107.50190527241, 47.9721133943178],
        [107.501937821573, 47.9720665720147],
        [107.501975131747, 47.9720173970853],
        [107.502059025004, 47.9719170309463],
        [107.50221103651, 47.9717478342952],
        [107.502330037501, 47.9716160881121],
        [107.502419734983, 47.9715221764074],
        [107.5025054062, 47.9714396348313],
        [107.502588847098, 47.971367103609],
        [107.502714539045, 47.9712592443187],
        [107.502776946599, 47.9712106476533],
        [107.502810803376, 47.9711877104445],
        [107.502844008145, 47.9711679208629],
        [107.502877142766, 47.9711509344681],
        [107.502910521104, 47.9711365929795],
        [107.502977533187, 47.9711140883446],
        [107.503054561019, 47.9710947933901],
        [107.503141748493, 47.9710786658478],
        [107.503239903199, 47.971065555531],
        [107.503291169052, 47.971061171336],
        [107.503349065607, 47.9710588474879],
        [107.503556540102, 47.971058649637],
        [107.503756798438, 47.9710567682553],
        [107.503955742863, 47.9710568078254],
        [107.504153237582, 47.9710587674482],
        [107.504349157588, 47.9710626453249],
        [107.504579758149, 47.971070894806],
        [107.504836795182, 47.9710850015716],
        [107.505079110313, 47.9711014852454],
        [107.505621009402, 47.9711416669544],
        [107.505859349529, 47.9711574005936],
        [107.506130898922, 47.971175351961],
        [107.506739097831, 47.9712197146182],
        [107.507007462724, 47.9712368395086],
        [107.507323846918, 47.9712516189671],
        [107.507468813135, 47.9712556704129],
        [107.507607537158, 47.9712575787743],
        [107.507782485873, 47.9712572496224],
        [107.507976877031, 47.9712541397668],
        [107.508573275037, 47.9712364779811],
        [107.508692366859, 47.9712345363448],
        [107.508960128307, 47.9712342836353],
        [107.509076783867, 47.9712318033052],
        [107.509212961909, 47.9712236329643],
        [107.509274470141, 47.9712172522744],
        [107.509332685055, 47.9712092375163],
        [107.509449264172, 47.9711878651279],
        [107.509574440808, 47.9711587028119],
        [107.509711095491, 47.9711212154718],
        [107.509880609603, 47.971069545823],
        [107.510021433542, 47.9710246058009],
        [107.510121564958, 47.9709900646398],
        [107.510209167919, 47.9709562078627],
        [107.510285532052, 47.9709223357972],
        [107.510339820526, 47.9708948803945],
        [107.510394206128, 47.9708643897798],
        [107.510449007216, 47.9708306894848],
        [107.510504764283, 47.9707934485589],
        [107.510619693144, 47.970708262976],
        [107.510760843538, 47.9705926605229],
        [107.510842480396, 47.9705209404891],
        [107.510922590205, 47.970444455847],
        [107.511001198147, 47.9703631841137],
        [107.511078349187, 47.9702770758265],
        [107.511135448942, 47.9702047388577],
        [107.511265077222, 47.9700157085582],
        [107.511298639021, 47.9699705715847],
        [107.51133098044, 47.9699309834282],
        [107.511433147921, 47.9698173612823],
        [107.511526986781, 47.9697244828986],
        [107.511628899754, 47.9696277698058],
        [107.51168469909, 47.9695796614723],
        [107.511743241358, 47.9695377224879],
        [107.511772294856, 47.9695205400409],
        [107.511801633439, 47.9695056202882],
        [107.51186162991, 47.9694813763645],
        [107.511933538802, 47.9694593600615],
        [107.512016763863, 47.9694393078778],
        [107.512145792295, 47.9694129460507],
        [107.51224150714, 47.9693955279813],
        [107.512340383102, 47.9693811891906],
        [107.512441912065, 47.9693700025236],
        [107.512545508568, 47.969362033631],
        [107.512650611437, 47.9693573274787],
        [107.512756462541, 47.969355923637],
        [107.512862335229, 47.9693578293005],
        [107.512967464177, 47.9693630327778],
        [107.513089592111, 47.9693719324688],
        [107.513181463254, 47.9693813699543],
        [107.513262503862, 47.9693933453267],
        [107.513334160943, 47.9694082183147],
        [107.513405655247, 47.9694283865108],
        [107.51348175408, 47.9694553203068],
        [107.513563733579, 47.9694892409358],
        [107.513673325863, 47.9695391470141],
        [107.513762900138, 47.9695846787899],
        [107.513857337946, 47.9696405734538],
        [107.513935128403, 47.9696913851494],
        [107.514104090332, 47.9698076045374],
        [107.514180098333, 47.9698579719679],
        [107.514345176988, 47.9699657476212],
        [107.514708744113, 47.9702079944035],
        [107.514867737956, 47.9703111889103],
        [107.515035857219, 47.970423662622],
        [107.515083979942, 47.9704522898414],
        [107.515129304874, 47.9704757414623],
        [107.515204464814, 47.9705079515808],
        [107.515291735925, 47.9705386742205],
        [107.515392482477, 47.9705686279399],
        [107.515531806348, 47.9706052762125],
        [107.515654903751, 47.970635813592],
        [107.515749827193, 47.9706566014211],
        [107.515836221464, 47.9706719330633],
        [107.515915896002, 47.9706820000743],
        [107.51599414961, 47.9706868914869],
        [107.516082542176, 47.9706871046262],
        [107.516158164368, 47.9706843239225],
        [107.51640667223, 47.970671242384],
        [107.516715245812, 47.9706588254445],
        [107.517408870423, 47.9706214783986],
        [107.517571377017, 47.9706148018317],
        [107.51771913473, 47.9706105354479],
        [107.518073693346, 47.9705981050186],
        [107.518207914464, 47.9705953162209],
        [107.518351640516, 47.9705969592823],
        [107.518479561882, 47.9706044965004],
        [107.518640400234, 47.9706190205514],
        [107.518748349457, 47.9706321380628],
        [107.518843641621, 47.9706487161654],
        [107.518926463785, 47.9706691892317],
        [107.518983905283, 47.9706881118669],
        [107.519045736372, 47.9707127272106],
        [107.519233987858, 47.97080079602],
        [107.519404229522, 47.9708737364338],
        [107.519467858355, 47.9709035813353],
        [107.519529054522, 47.9709386306134],
        [107.519553865019, 47.9709562546275],
        [107.5195752473, 47.9709742320752],
        [107.519610571771, 47.9710131763171],
        [107.519641445496, 47.9710609941696],
        [107.519665955619, 47.9711111898296],
        [107.51971431936, 47.9712266052237],
        [107.519770122293, 47.9713587201289],
        [107.519789969432, 47.9714157812134],
        [107.519805380214, 47.9714693880019],
        [107.519812604468, 47.971503962438],
        [107.519817530954, 47.9715421179744],
        [107.519825192279, 47.9717259268101],
        [107.5198300729, 47.9717700592409],
        [107.519837771996, 47.9718092436017],
        [107.519867858815, 47.9719184869487],
        [107.519900129188, 47.9720083085367],
        [107.51993773344, 47.9720874209977],
        [107.519958799159, 47.9721234262552],
        [107.519981507041, 47.9721572983207],
        [107.520031061484, 47.9722189612361],
        [107.520093146182, 47.9722830972872],
        [107.520168808843, 47.9723508971762],
        [107.520264108202, 47.9724278044997],
        [107.520371272316, 47.972508171515],
        [107.520464004111, 47.9725706276324],
        [107.520553010013, 47.972622366529],
        [107.520640150722, 47.972664329795],
        [107.520735831394, 47.9727020221806],
        [107.520836551865, 47.9727349706424],
        [107.520939517045, 47.9727622587713],
        [107.521042166563, 47.9727832138743],
        [107.521137154756, 47.9727958610402],
        [107.521245156139, 47.9728029944627],
        [107.521362407049, 47.972805148339],
        [107.521566178137, 47.9728036329813],
        [107.521777483744, 47.9728000024182],
        [107.521964365563, 47.9727910604591],
        [107.522135316791, 47.9727763889193],
        [107.522215646035, 47.9727668273273],
        [107.522292900497, 47.9727557377871],
        [107.522408788035, 47.9727353672434],
        [107.522531377321, 47.9727094451848],
        [107.522662815037, 47.9726775408359],
        [107.522810176149, 47.9726379445855],
        [107.52292904404, 47.9726019555159],
        [107.523200275972, 47.9725123003025],
        [107.523332486205, 47.9724733281816],
        [107.523603119189, 47.9724000775016],
        [107.523716526397, 47.9723677792497],
        [107.523833172063, 47.9723308791668],
        [107.523934530155, 47.972293945809],
        [107.523997135559, 47.9722669958252],
        [107.524064090086, 47.9722335905079],
        [107.524277699756, 47.9721123124334],
        [107.524358677411, 47.972069608126],
        [107.524442442065, 47.972032157658],
        [107.524482759572, 47.9720171218927],
        [107.524522659793, 47.972004302057],
        [107.524589730332, 47.9719860512154],
        [107.524664361471, 47.9719686951992],
        [107.524748247534, 47.9719517942399],
        [107.524852015808, 47.9719332025553],
        [107.524983480503, 47.9719121089567],
        [107.525100161244, 47.9718967269524],
        [107.525208102372, 47.9718862651391],
        [107.525309062963, 47.9718805778265],
        [107.525431124347, 47.9718799662875],
        [107.525564567551, 47.9718861428313],
        [107.525712349545, 47.9718991029613],
        [107.525897431821, 47.9719208449711],
        [107.525967546565, 47.9719310441824],
        [107.526043796484, 47.971944729166],
        [107.526382606172, 47.9720181705022],
        [107.526463899489, 47.97203358758],
        [107.526537448744, 47.97204511509],
        [107.526731356067, 47.9720688823731],
        [107.526924107761, 47.9720864901994],
        [107.52711436024, 47.9720978198585],
        [107.527301008235, 47.9721028065993],
        [107.527418603586, 47.9721022885898],
        [107.527547503415, 47.9720984871555],
        [107.527690109811, 47.9720914706449],
        [107.527886265439, 47.972079275838],
        [107.528201659479, 47.9720593144858],
        [107.528386053773, 47.9720438758243],
        [107.528473958007, 47.9720342063136],
        [107.528555878151, 47.9720233353087],
        [107.528633128116, 47.9720110892404],
        [107.528706401279, 47.9719973565928],
        [107.528796239955, 47.9719831131302],
        [107.528887433009, 47.9719735083707],
        [107.528979449842, 47.9719685962738],
        [107.529071756257, 47.9719684074161],
        [107.529163818056, 47.9719729399993],
        [107.529215596523, 47.971980211018],
        [107.529444444306, 47.972055556219],
        [107.529621556789, 47.9721267042841],
        [107.529667860184, 47.9721611519157],
        [107.529714204947, 47.9722096604475],
        [107.529752145545, 47.9722613552774],
        [107.529781205338, 47.9723155825981],
        [107.529801016504, 47.9723716580257],
        [107.529822970754, 47.972455373217],
        [107.529823711795, 47.9724745980243],
        [107.529813267968, 47.9725717481877],
        [107.529785203724, 47.97266749361],
        [107.529766344042, 47.9727466195609],
        [107.529755966765, 47.9728147683869],
        [107.529753157282, 47.9728771489613],
        [107.529755246408, 47.972985349994],
        [107.529760650434, 47.9730557570176],
        [107.529771659934, 47.9731188543517],
        [107.529788815402, 47.9731743605084],
        [107.529805397101, 47.9732111113038],
        [107.529826879207, 47.9732487704145],
        [107.529853438885, 47.9732876553011],
        [107.529885483528, 47.9733283676101],
        [107.529960637174, 47.9734105881282],
        [107.530103055612, 47.9735505721013],
        [107.530169392304, 47.9736132044858],
        [107.530243201463, 47.9736764403155],
        [107.530325182761, 47.97374089023],
        [107.530416784107, 47.9738076918715],
        [107.530506091283, 47.9738690364269],
        [107.530608408951, 47.9739361726163],
        [107.531000434223, 47.9741835428363],
        [107.531199473077, 47.9743101880648],
        [107.531381655039, 47.9744230610755],
        [107.53155410274, 47.974526573043],
        [107.531719549218, 47.9746223490422],
        [107.531881344449, 47.9747122848441],
        [107.532039419184, 47.9747962959124],
        [107.532194777067, 47.974874915545],
        [107.532348083597, 47.9749484764911],
        [107.532596601352, 47.9750607181776],
        [107.532845124503, 47.9751655881215],
        [107.53309306939, 47.9752628444048],
        [107.533339962969, 47.9753522999687],
        [107.533665544529, 47.9754659113228],
        [107.533861375502, 47.9755288782552],
        [107.533956707236, 47.975556325564],
        [107.534047304939, 47.9755798949962],
        [107.534134601231, 47.975599961569],
        [107.53421936683, 47.9756166952544],
        [107.534370300049, 47.975642511193],
        [107.534493494579, 47.9756599580407],
        [107.534605377436, 47.9756713533503],
        [107.534708375891, 47.9756768491073],
        [107.534840103188, 47.9756768446107],
        [107.534973605747, 47.9756700574272],
        [107.535106083979, 47.9756566305491],
        [107.535234749084, 47.9756368445648],
        [107.53529806945, 47.9756237144629],
        [107.535367638306, 47.9756060841535],
        [107.535630984982, 47.975528760444],
        [107.53593270573, 47.975443825772],
        [107.536015155575, 47.975422496551],
        [107.536089855063, 47.9754051009647],
        [107.536216286253, 47.975377698622],
        [107.536299496025, 47.9753613543431],
        [107.53637604362, 47.9753488672565],
        [107.53644595062, 47.9753404720852],
        [107.536570412295, 47.9753316470379],
        [107.536690832416, 47.9753293474715],
        [107.536804843968, 47.9753336111573],
        [107.53685900384, 47.9753381905051],
        [107.536911070989, 47.9753443841361],
        [107.537002846804, 47.9753604900946],
        [107.537101259615, 47.9753846063146],
        [107.537208301422, 47.9754170826323],
        [107.537339530495, 47.9754626269987],
        [107.537403137745, 47.9754874878573],
        [107.537471625615, 47.9755180333306],
        [107.537690210335, 47.9756274322602],
        [107.537772161056, 47.9756659169486],
        [107.537969851827, 47.9757565470271],
        [107.538053690226, 47.9757930828845],
        [107.53814266735, 47.9758276914948],
        [107.538225209826, 47.9758545641369],
        [107.538312583459, 47.975877340367],
        [107.538411856022, 47.9758981929473],
        [107.538522719048, 47.9759174114594],
        [107.538694505747, 47.9759435178791],
        [107.538770493064, 47.9759524742274],
        [107.53892062139, 47.9759639315902],
        [107.538981871516, 47.9759699642425],
        [107.539044303352, 47.975979220065],
        [107.539098386781, 47.9759913474228],
        [107.539174017967, 47.9760127845624],
        [107.539229772336, 47.9760315012529],
        [107.539276151273, 47.9760510255344],
        [107.539313665593, 47.9760717270286],
        [107.539350978465, 47.976099871312],
        [107.539385790322, 47.9761347596115],
        [107.539418075084, 47.9761763550548],
        [107.539447977542, 47.9762248482982],
        [107.539464509779, 47.97626400478],
        [107.539474082163, 47.9763096049044],
        [107.539477361991, 47.976353826368],
        [107.539478683095, 47.9764527383033],
        [107.539482303765, 47.9764937051204],
        [107.539491269107, 47.9765691168713],
        [107.539507812136, 47.9767478112625],
        [107.539519809991, 47.9768355284369],
        [107.539529609004, 47.9768856593458],
        [107.539541326271, 47.9769320400816],
        [107.539555197414, 47.976975593349],
        [107.539571370822, 47.9770167751041],
        [107.539598272243, 47.9770753470497],
        [107.539626408432, 47.9771296121419],
        [107.539656056382, 47.9771801045782],
        [107.539687359984, 47.9772270635782],
        [107.539761564844, 47.9773253199077],
        [107.539796186045, 47.9773658649428],
        [107.539830639972, 47.9774024862358],
        [107.539865903289, 47.9774361442627],
        [107.539901815916, 47.977466614193],
        [107.539938605382, 47.9774940857835],
        [107.539976412881, 47.977518664255],
        [107.540031750865, 47.9775491548697],
        [107.540095927385, 47.9775791004951],
        [107.540169786007, 47.9776089256115],
        [107.540257118271, 47.9776401653614],
        [107.540375916915, 47.9776769584249],
        [107.540495387352, 47.9777067718501],
        [107.540613020475, 47.9777289851046],
        [107.540670605864, 47.9777371383583],
        [107.540727130053, 47.9777432861238],
        [107.540815024394, 47.9777484311452],
        [107.54091345789, 47.9777485741374],
        [107.541021653527, 47.9777441548689],
        [107.541191574132, 47.9777330050742],
        [107.541339247308, 47.9777241152757],
        [107.541414882991, 47.9777178613903],
        [107.541486499602, 47.9777087377681],
        [107.541549070833, 47.9776967093357],
        [107.54162704745, 47.9776775070114],
        [107.541687235478, 47.9776596293884],
        [107.541737298937, 47.9776407957862],
        [107.541777814295, 47.9776206932404],
        [107.541804049317, 47.9776032104199],
        [107.541828014451, 47.9775824630603],
        [107.541849905749, 47.9775582838877],
        [107.541870061354, 47.9775303095762],
        [107.541903122231, 47.9774690855299],
        [107.541954585036, 47.9773471635408],
        [107.541972807999, 47.9772993924531],
        [107.541986672847, 47.9772454780964],
        [107.541996306384, 47.9771882443421],
        [107.542016803733, 47.9770265759158],
        [107.542027011038, 47.9769773128527],
        [107.542039946886, 47.9769337550888],
        [107.542093612131, 47.9767742729144],
        [107.54211187916, 47.9767278076422],
        [107.542130550884, 47.9766870197902],
        [107.542152707482, 47.9766463245683],
        [107.542176818306, 47.9766096475172],
        [107.542203257474, 47.976576418467],
        [107.542232255214, 47.9765463586276],
        [107.5422866615, 47.9765010723667],
        [107.542354347175, 47.9764551889559],
        [107.542436303293, 47.9764079367769],
        [107.542539862025, 47.9763550710297],
        [107.542652598339, 47.9763030911148],
        [107.542757899058, 47.9762611575264],
        [107.542858470242, 47.9762281973735],
        [107.542907240477, 47.9762150034197],
        [107.542955109591, 47.9762039705369],
        [107.543024672151, 47.9761918072062],
        [107.543104213589, 47.9761825432898],
        [107.543187276771, 47.9761762012707],
        [107.543354814173, 47.9761667332082],
        [107.543557118466, 47.9761569045176],
        [107.543759324733, 47.976153015849],
        [107.543959971575, 47.976155095981],
        [107.544157708212, 47.9761631323228],
        [107.54430219599, 47.976174297406],
        [107.544462672814, 47.9761926201933],
        [107.544613525994, 47.9762137003021],
        [107.544948564824, 47.9762645281855],
        [107.545093539136, 47.9762842898881],
        [107.545212024815, 47.9762975324052],
        [107.545498356364, 47.9763239751714],
        [107.545627444151, 47.9763379533339],
        [107.545762216553, 47.9763572464898],
        [107.545880204908, 47.9763803680596],
        [107.546028657796, 47.9764167213547],
        [107.546163276414, 47.9764551098155],
        [107.546285319812, 47.9764958949696],
        [107.54639522506, 47.9765392270038],
        [107.5464378853, 47.9765587764664],
        [107.546480666949, 47.9765808395342],
        [107.546568663813, 47.9766336054566],
        [107.546650944585, 47.976690484878],
        [107.546859933539, 47.9768446709448],
        [107.546924231468, 47.9768874642851],
        [107.546984744151, 47.9769234776364],
        [107.54706182954, 47.976965207978],
        [107.547143898972, 47.9770072189081],
        [107.547326296771, 47.9770937552726],
        [107.54753171002, 47.9771836173301],
        [107.547849409023, 47.9773158068791],
        [107.548008959546, 47.9773793340891],
        [107.548188454334, 47.9774458290618],
        [107.54837902787, 47.9775126316027],
        [107.548916898896, 47.9776961301723],
        [107.549081032364, 47.9777551131081],
        [107.549226336726, 47.9778102784217],
        [107.549302903206, 47.9778419444502],
        [107.549385692995, 47.9778794812531],
        [107.549722532269, 47.9780465635981],
        [107.549801458571, 47.9780835410227],
        [107.549873309006, 47.9781148005577],
        [107.54995825447, 47.9781480098229],
        [107.550039599048, 47.9781753689981],
        [107.550118992997, 47.9781974293679],
        [107.550197289773, 47.9782144211587],
        [107.550315205283, 47.9782344229803],
        [107.550424301141, 47.9782488463073],
        [107.550526462326, 47.9782579348559],
        [107.550622307574, 47.9782617389881],
        [107.550702901218, 47.9782611202546],
        [107.550786333123, 47.9782572783508],
        [107.550872077185, 47.9782502384578],
        [107.550959386966, 47.9782400581322],
        [107.551054587399, 47.9782260979561],
        [107.551135976045, 47.9782113202962],
        [107.551208483884, 47.9781948231326],
        [107.551273260253, 47.9781763222795],
        [107.551343418164, 47.9781503453622],
        [107.551417301068, 47.9781159669784],
        [107.551492042824, 47.9780754570168],
        [107.551623762027, 47.9779982475212],
        [107.551743323296, 47.9779248349632],
        [107.551865460223, 47.9778413005357],
        [107.551992669326, 47.9777460083716],
        [107.552134063436, 47.9776321452074],
        [107.552204784323, 47.97757043193],
        [107.552278561107, 47.9774997128415],
        [107.552350394455, 47.977425865911],
        [107.552541252177, 47.9772229401866],
        [107.552601451896, 47.9771626325495],
        [107.552657777335, 47.9771096489912],
        [107.552827809456, 47.9769547686477],
        [107.552929877112, 47.9768657411611],
        [107.553029450049, 47.9767853372736],
        [107.55312444184, 47.9767161335428],
        [107.553194232828, 47.9766698463364],
        [107.553268804612, 47.9766236058948],
        [107.553348427888, 47.9765772449439],
        [107.553433539726, 47.9765305053785],
        [107.55352406998, 47.9764833997891],
        [107.553621580771, 47.9764350900074],
        [107.553845124353, 47.97633115356],
        [107.554008577034, 47.9762594506132],
        [107.554162069724, 47.976195752532],
        [107.554309034235, 47.9761386374882],
        [107.554450950851, 47.9760875380096],
        [107.554589598431, 47.976041842557],
        [107.554724989567, 47.9760015799091],
        [107.554857669246, 47.9759665872882],
        [107.554987998997, 47.9759367720644],
        [107.555203532317, 47.9758939634357],
        [107.555384034346, 47.9758644782631],
        [107.555468269345, 47.9758535568962],
        [107.555548920546, 47.9758451608255],
        [107.555626563515, 47.975839233394],
        [107.555701544491, 47.9758357458231],
        [107.555822818069, 47.9758340595942],
        [107.555941684161, 47.975836521938],
        [107.556056847745, 47.9758431049754],
        [107.55616736813, 47.9758537538477],
        [107.556263084774, 47.9758671510482],
        [107.556365930343, 47.9758857796051],
        [107.556478348297, 47.9759100055424],
        [107.556615581244, 47.9759431050903],
        [107.556667927183, 47.9759572388356],
        [107.556725321017, 47.9759748313734],
        [107.556970452824, 47.9760573522651],
        [107.557031377396, 47.9760749484002],
        [107.557087709131, 47.9760886810478],
        [107.557232832729, 47.976117056457],
        [107.557378352929, 47.9761387723865],
        [107.557521962968, 47.9761534915904],
        [107.557661885787, 47.9761610324058],
        [107.557768295371, 47.9761616979041],
        [107.557882747591, 47.9761578380139],
        [107.558006938569, 47.9761494149636],
        [107.558146721094, 47.9761360384475],
        [107.558231971428, 47.9761254264473],
        [107.558320229995, 47.9761114986468],
        [107.558412384424, 47.9760941183489],
        [107.55851015422, 47.9760729635964],
        [107.558695084511, 47.9760271800104],
        [107.55910797855, 47.9759159473631],
        [107.559188025407, 47.9758940749517],
        [107.559275654448, 47.9758676061052],
        [107.55960273248, 47.9757593529118],
        [107.559740985258, 47.975716979555],
        [107.559816929408, 47.975696421053],
        [107.559888734877, 47.9756793096525],
        [107.5599578172, 47.9756653054096],
        [107.560024902128, 47.9756542662315],
        [107.560130518509, 47.9756407404279],
        [107.560242500291, 47.975629816363],
        [107.560361315123, 47.9756214454734],
        [107.560487919882, 47.9756155585113],
        [107.560568504533, 47.9756137400821],
        [107.56065815435, 47.9756137589679],
        [107.560931930464, 47.9756198437808],
        [107.561034642934, 47.9756237252548],
        [107.561148699453, 47.9756310574274],
        [107.561554038288, 47.9756673504679],
        [107.561716383904, 47.9756789094542],
        [107.561802893289, 47.9756826884054],
        [107.56188374324, 47.975684183978],
        [107.561960468001, 47.9756834240508],
        [107.562033857177, 47.9756803960335],
        [107.562141423288, 47.9756732716043],
        [107.562238529385, 47.975664924097],
        [107.562328466086, 47.9756550684267],
        [107.562412433087, 47.9756435651984],
        [107.562574777804, 47.9756207475995],
        [107.562655796828, 47.9756063188765],
        [107.56272928313, 47.9755873683624],
        [107.562760650584, 47.9755763732511],
        [107.562788901886, 47.9755642090211],
        [107.562855230485, 47.975528204663],
        [107.562913620767, 47.9754876884061],
        [107.562938390794, 47.9754667333032],
        [107.56295988639, 47.9754455974364],
        [107.562977893515, 47.9754244921467],
        [107.56299227907, 47.9754035739159],
        [107.563006939818, 47.9753733638897],
        [107.563017295512, 47.9753383236048],
        [107.563023616847, 47.9752979431456],
        [107.563026777964, 47.9752467114666],
        [107.563025239223, 47.9752125183431],
        [107.563018345021, 47.9751743870884],
        [107.562973326758, 47.9750208593252],
        [107.562960943093, 47.9749733850137],
        [107.562927021565, 47.9748651246259],
        [107.562915280916, 47.974816085494],
        [107.562909751884, 47.9747597132902],
        [107.562911274436, 47.97473417794],
        [107.562915664926, 47.9747099591973],
        [107.562931616201, 47.9746483565365],
        [107.562946998205, 47.9746084212417],
        [107.562967158308, 47.9745761427748],
        [107.562979100405, 47.9745631547659],
        [107.562992382492, 47.9745521533592],
        [107.563007581035, 47.9745426852967],
        [107.563025730253, 47.9745339852553],
        [107.563071458981, 47.9745186356266],
        [107.563127891439, 47.9745060325274],
        [107.563221777963, 47.9744902692106],
        [107.563313028573, 47.9744785726281],
        [107.563409195778, 47.9744731659039],
        [107.563506774918, 47.9744742504863],
        [107.563601749621, 47.9744817841071],
        [107.563678969909, 47.9744945140106],
        [107.563763038533, 47.9745158054601],
        [107.56384935996, 47.9745434389286],
        [107.564009147904, 47.9746003974904],
        [107.564124350159, 47.9746439885293],
        [107.564248495272, 47.9746979379596],
        [107.564360035487, 47.9747509574907],
        [107.564657883754, 47.9748980919734],
        [107.564762867912, 47.974950364168],
        [107.564976838211, 47.9750634943848],
        [107.56507001337, 47.9751109300254],
        [107.565170794097, 47.9751581165539],
        [107.565264409925, 47.9751967271473],
        [107.565407949817, 47.9752493132053],
        [107.565538695055, 47.9752923538591],
        [107.565661974121, 47.9753275964914],
        [107.565779474143, 47.9753554988573],
        [107.565848101409, 47.9753689716008],
        [107.565919910476, 47.9753810153217],
        [107.566074016503, 47.9754009739758],
        [107.566244036033, 47.9754157030723],
        [107.566438095342, 47.9754259175721],
        [107.566564097555, 47.975428659605],
        [107.566701753183, 47.9754274104467],
        [107.56685433396, 47.9754222510361],
        [107.567050279147, 47.9754122280919],
        [107.567373584523, 47.9753919951445],
        [107.56749918384, 47.975381655639],
        [107.567613733187, 47.9753701694978],
        [107.567723686099, 47.9753567839884],
        [107.567826883304, 47.9753416421032],
        [107.567924473236, 47.9753245720714],
        [107.568017107903, 47.9753054614779],
        [107.568199785392, 47.9752659902333],
        [107.568296685544, 47.9752416141093],
        [107.568342341426, 47.9752278373948],
        [107.568383523181, 47.9752134716244],
        [107.568420896307, 47.9751982865717],
        [107.568454784561, 47.975182146439],
        [107.568530993111, 47.9751385086353],
        [107.568599194997, 47.9750907681245],
        [107.568655775843, 47.9750414717865],
        [107.568679124042, 47.9750167512221],
        [107.568698953194, 47.9749922078242],
        [107.568717909104, 47.9749633099089],
        [107.568733978191, 47.9749318462278],
        [107.568747138869, 47.9748978572504],
        [107.568757371356, 47.9748614005332],
        [107.568764660361, 47.9748225048548],
        [107.568768970811, 47.9747813150057],
        [107.568770292815, 47.9747379595892],
        [107.568768618277, 47.9746926526439],
        [107.568760527976, 47.9746307406162],
        [107.56874489596, 47.9745688016089],
        [107.568722269018, 47.974508988599],
        [107.568693329733, 47.9744531011298],
        [107.568671125472, 47.9744201014066],
        [107.568643671868, 47.9743868040078],
        [107.568610753084, 47.9743529436335],
        [107.568571886184, 47.9743180175625],
        [107.568530498484, 47.9742845627824],
        [107.568481818181, 47.9742482778358],
        [107.568318294454, 47.9741351152434],
        [107.568267005218, 47.9741013268148],
        [107.56821079759, 47.9740681526232],
        [107.56814915446, 47.9740352815031],
        [107.568081070385, 47.9740021765593],
        [107.567937557472, 47.9739396520933],
        [107.567644949555, 47.9738232591362],
        [107.567524691312, 47.9737729222826],
        [107.567403788254, 47.9737165680652],
        [107.567301551525, 47.9736611986055],
        [107.567088895136, 47.973542998011],
        [107.5670016582, 47.9734898876483],
        [107.566959083395, 47.9734601839404],
        [107.566922436022, 47.9734311124559],
        [107.566891045186, 47.9734021371989],
        [107.566864606916, 47.9733729730843],
        [107.56682454122, 47.9733187232805],
        [107.566791001004, 47.9732619445832],
        [107.566765177871, 47.9732046613661],
        [107.566747816459, 47.9731485391738],
        [107.566736596517, 47.9730825352308],
        [107.566734375191, 47.9730189153907],
        [107.566741220831, 47.9729600448702],
        [107.566756975154, 47.9729070990834],
        [107.5667754859, 47.9728688509168],
        [107.566800228947, 47.9728299381512],
        [107.566830679992, 47.9727911872635],
        [107.566866112381, 47.9727535218576],
        [107.566905650176, 47.9727178745304],
        [107.566948332, 47.9726851095302],
        [107.56699314162, 47.9726560065695],
        [107.567039141044, 47.9726311717912],
        [107.567075476352, 47.9726152438984],
        [107.567116167078, 47.9726007090555],
        [107.567161381393, 47.9725875070079],
        [107.567211444852, 47.9725755424274],
        [107.567265523785, 47.9725649295279],
        [107.56732576847, 47.9725551763804],
        [107.567478203556, 47.972536211477],
        [107.567537276424, 47.9725308749],
        [107.567599413282, 47.9725275788847],
        [107.567665006235, 47.9725262982501],
        [107.567734764848, 47.972527021305],
        [107.567886280827, 47.9725341871031],
        [107.568091758828, 47.9725508659297],
        [107.568220510268, 47.9725641318293],
        [107.568349800403, 47.9725811640895],
        [107.568478887291, 47.972601866483],
        [107.568607015501, 47.9726261149033],
        [107.568733424208, 47.9726537681569],
        [107.568857384061, 47.9726846643658],
        [107.568978172904, 47.9727186245649],
        [107.569095118945, 47.9727554589973],
        [107.569168344444, 47.9727812533522],
        [107.569243265165, 47.9728104786208],
        [107.569320639236, 47.9728434243846],
        [107.569401930755, 47.9728807138739],
        [107.569552265924, 47.9729553099397],
        [107.569895843818, 47.9731348640827],
        [107.56995858592, 47.9731686588066],
        [107.570094237859, 47.9732481669694],
        [107.570155394456, 47.9732818978414],
        [107.570222721302, 47.9733142959181],
        [107.570286360028, 47.973338976013],
        [107.570333685052, 47.9733539029603],
        [107.570384031798, 47.9733676904666],
        [107.570494059353, 47.9733919164039],
        [107.570617109092, 47.9734118148035],
        [107.570755683828, 47.9734277984542],
        [107.570893897036, 47.9734384329374],
        [107.571019801223, 47.9734424987723],
        [107.571135587138, 47.9734400634082],
        [107.5711898918, 47.9734363977716],
        [107.571241892399, 47.9734310980668],
        [107.571334471309, 47.9734170623476],
        [107.57143155762, 47.9733966936026],
        [107.571533020932, 47.9733700161134],
        [107.571638735339, 47.9733370658529],
        [107.57169004436, 47.9733185371208],
        [107.571741997295, 47.9732970613104],
        [107.571795128343, 47.9732724198863],
        [107.571850472621, 47.9732441389059],
        [107.571947415041, 47.9731894133608],
        [107.572194586511, 47.9730408048893],
        [107.572266223807, 47.9729975430022],
        [107.572342361311, 47.9729465190667],
        [107.572418052751, 47.9728918510781],
        [107.57262085347, 47.9727401246571],
        [107.572683990374, 47.972695804268],
        [107.572742196295, 47.9726577071875],
        [107.572811517837, 47.9726165281303],
        [107.572879176533, 47.9725812162502],
        [107.572946522264, 47.9725510691766],
        [107.573014271791, 47.972525773046],
        [107.573130189906, 47.9724896238971],
        [107.573246832875, 47.9724589426261],
        [107.573361875051, 47.9724343362756],
        [107.573473726431, 47.9724161402927],
        [107.573568793765, 47.9724040794848],
        [107.573651864142, 47.9723954522884],
        [107.573728273241, 47.9723897110164],
        [107.573799209966, 47.9723867828238],
        [107.573866347954, 47.9723866479255],
        [107.573929276215, 47.9723893548848],
        [107.573988318506, 47.972394920789],
        [107.574043651993, 47.9724033609264],
        [107.574127506579, 47.9724219256314],
        [107.574211484373, 47.9724465508677],
        [107.574292094205, 47.9724762132067],
        [107.574365919552, 47.972509657195],
        [107.574420419367, 47.9725416829523],
        [107.574474447038, 47.9725829690288],
        [107.574521110161, 47.9726256067864],
        [107.574623568123, 47.9727273389955],
        [107.574674833976, 47.9727723455674],
        [107.574736758595, 47.9728241141416],
        [107.574890570543, 47.9729586599143],
        [107.57497783446, 47.9730279733623],
        [107.575028754973, 47.9730635271601],
        [107.575078752782, 47.9730944044832],
        [107.575128788363, 47.9731211943877],
        [107.57517937253, 47.9731441657707],
        [107.575268638337, 47.9731781709359],
        [107.575361182173, 47.9732076857861],
        [107.575453743096, 47.9732316778996],
        [107.575543862359, 47.9732495114558],
        [107.575621521516, 47.9732596935801],
        [107.575704183601, 47.9732653431211],
        [107.575791987111, 47.9732664717703],
        [107.575885191049, 47.9732630831248],
        [107.575983525619, 47.9732552284461],
        [107.576088274155, 47.9732428420835],
        [107.576200432204, 47.9732258179172],
        [107.576323474749, 47.9732036352396],
        [107.576466338351, 47.9731733280867],
        [107.57659243949, 47.9731405190198],
        [107.576704308857, 47.97310454344],
        [107.576755126848, 47.9730852925522],
        [107.576802625441, 47.9730651675235],
        [107.576904637339, 47.9730152308683],
        [107.576998298133, 47.972960834475],
        [107.577041094171, 47.9729324806495],
        [107.577080914353, 47.972903545862],
        [107.577117559928, 47.9728741785006],
        [107.577150885205, 47.9728444927792],
        [107.577195167823, 47.9727982442436],
        [107.577237680575, 47.9727445322344],
        [107.577279422607, 47.9726824007722],
        [107.577328861937, 47.972599261147],
        [107.577363629728, 47.9725310988312],
        [107.577394862283, 47.9724532409244],
        [107.577419054046, 47.9723797681119],
        [107.577477260867, 47.9721844092831],
        [107.577499172849, 47.972108385094],
        [107.577536357117, 47.9719517744549],
        [107.577554152902, 47.9718854197764],
        [107.577577318538, 47.9718164858422],
        [107.577603843143, 47.9717558562478],
        [107.577660124515, 47.9716362599056],
        [107.577693823911, 47.9715764414996],
        [107.577713519064, 47.9715483736585],
        [107.577734313188, 47.9715235532694],
        [107.57775654353, 47.9715015846305],
        [107.577780404342, 47.9714822743875],
        [107.57780859629, 47.9714635639924],
        [107.577840912528, 47.9714455307867],
        [107.577877425903, 47.971428131603],
        [107.577918291996, 47.9714112935964],
        [107.578013201048, 47.9713791518265],
        [107.578132885524, 47.9713466449318],
        [107.578227513089, 47.9713254910786],
        [107.578319463373, 47.9713098572641],
        [107.578407117594, 47.971300015983],
        [107.578489601614, 47.9712960625633],
        [107.578550731231, 47.9712966624111],
        [107.578613074934, 47.9712999566278],
        [107.578675595802, 47.9713058885559],
        [107.578737291992, 47.9713143655655],
        [107.578797101405, 47.9713252302752],
        [107.57885432077, 47.9713383495852],
        [107.578908218939, 47.9713535526244],
        [107.578958212252, 47.9713706766155],
        [107.578994592526, 47.9713855532008],
        [107.579031234504, 47.9714028840359],
        [107.579105596746, 47.9714450523474],
        [107.579181941993, 47.9714974891179],
        [107.579263612126, 47.9715624795249],
        [107.579294518227, 47.9715907425188],
        [107.579323493484, 47.9716218194914],
        [107.579350847264, 47.971656037796],
        [107.579377129951, 47.9716940836151],
        [107.57941943406, 47.9717666616022],
        [107.579509540733, 47.97194159323],
        [107.579535443006, 47.9719854612601],
        [107.579561327294, 47.9720240700548],
        [107.579670402467, 47.972182322856],
        [107.579719901153, 47.9722496110308],
        [107.579775704985, 47.9723161401778],
        [107.579832285831, 47.9723727390107],
        [107.579919581224, 47.9724502254975],
        [107.5799868676, 47.9725032162505],
        [107.580052449761, 47.9725461408917],
        [107.580084846039, 47.9725638332544],
        [107.580117293578, 47.9725791891783],
        [107.580159721794, 47.9725964408731],
        [107.580204911827, 47.9726123318936],
        [107.580252342971, 47.9726266787783],
        [107.580301436062, 47.9726393061591],
        [107.580351579562, 47.9726500584535],
        [107.580402153836, 47.9726588016624],
        [107.580452549146, 47.9726654305652],
        [107.580502190823, 47.9726698696189],
        [107.580562819519, 47.9726726278395],
        [107.580622619039, 47.9726726692083],
        [107.580680137878, 47.9726699928259],
        [107.580734383185, 47.9726646490544],
        [107.58080344842, 47.9726527051583],
        [107.580876856482, 47.9726338382811],
        [107.580955766595, 47.9726078190956],
        [107.581046768993, 47.9725724829338],
        [107.581157981855, 47.9725242477958],
        [107.581241483008, 47.9724812269271],
        [107.581276472032, 47.9724598194652],
        [107.581306938365, 47.9724384299896],
        [107.581333057375, 47.972416937092],
        [107.5813549118, 47.9723952688266],
        [107.58137983651, 47.972360684498],
        [107.581398424598, 47.9723185224819],
        [107.581410042939, 47.9722761275413],
        [107.581431039411, 47.9721729303365],
        [107.581447022162, 47.9721235818379],
        [107.581485809922, 47.9720441770971],
        [107.581585070794, 47.9718699739202],
        [107.58162073431, 47.9717932959239],
        [107.581630495551, 47.9717637729798],
        [107.58163808403, 47.971730159919],
        [107.581654287116, 47.9716051865302],
        [107.581664415281, 47.9715554684102],
        [107.581672738506, 47.9715295634387],
        [107.581682988079, 47.9715061019251],
        [107.581695369046, 47.9714846261147],
        [107.581710014506, 47.9714649102775],
        [107.581754690127, 47.9714160564059],
        [107.581800022253, 47.9713754735993],
        [107.581846130495, 47.9713430611334],
        [107.581892915026, 47.9713188936521],
        [107.581947127958, 47.9713001670691],
        [107.582011835078, 47.9712855638777],
        [107.582085704492, 47.9712754078338],
        [107.582165196467, 47.9712701980612],
        [107.582195477539, 47.9712702052558],
        [107.5822271004, 47.9712721405969],
        [107.582296069408, 47.9712819333146],
        [107.582361024742, 47.9712961021335],
        [107.582506470297, 47.9713329806326],
        [107.582570489437, 47.9713462213511],
        [107.58266819718, 47.9713643966496],
        [107.582913877573, 47.9714134915395],
        [107.583046205618, 47.9714361229787],
        [107.583119545331, 47.9714458788243],
        [107.583188122234, 47.9714525679817],
        [107.583253261029, 47.9714563199532],
        [107.583315629912, 47.9714571671146],
        [107.583451019249, 47.97145275594],
        [107.583577471123, 47.9714423058178],
        [107.583636901022, 47.9714348522367],
        [107.583693683317, 47.9714259273647],
        [107.58374773437, 47.9714155437924],
        [107.583798988533, 47.9714037168081],
        [107.583908383865, 47.9713732243948],
        [107.58400393953, 47.9713403271944],
        [107.584085067372, 47.9713052293529],
        [107.584120119348, 47.971286899371],
        [107.584151453527, 47.971268069366],
        [107.584188229503, 47.9712411202815],
        [107.584221935194, 47.9712098463574],
        [107.584252866477, 47.9711739831928],
        [107.584281519776, 47.9711329552218],
        [107.584305176443, 47.9710922204297],
        [107.584328600185, 47.9710451274307],
        [107.584406038108, 47.9708650085134],
        [107.584429304469, 47.970807112858],
        [107.584448788281, 47.9707411880555],
        [107.584463018254, 47.9706778793807],
        [107.584491281248, 47.9705311262106],
        [107.584507916008, 47.9704623649462],
        [107.584526902495, 47.9704035214054],
        [107.584549420619, 47.9703509263542],
        [107.584594541405, 47.970267870366],
        [107.584651856098, 47.9701783914197],
        [107.584721968144, 47.9700809327888],
        [107.584825105994, 47.9699473879616],
        [107.584981779586, 47.9697495973661],
        [107.585040360524, 47.9696804412994],
        [107.585095847795, 47.9696189582484],
        [107.585153170582, 47.9695600409632],
        [107.585210279331, 47.9695061751699],
        [107.585267939364, 47.9694566378137],
        [107.585326594047, 47.9694110511791],
        [107.585402217139, 47.969358319431],
        [107.585488922576, 47.969303552517],
        [107.58558868437, 47.9692454005548],
        [107.585716299967, 47.9691752273549],
        [107.585846703463, 47.9691084580889],
        [107.585995387477, 47.9690392669486],
        [107.586162410467, 47.9689671602063],
        [107.58641906259, 47.9688613963364],
        [107.586683797819, 47.9687555533262],
        [107.586935865198, 47.968660587616],
        [107.587179011302, 47.9685750881698],
        [107.587415184064, 47.968498377798],
        [107.587564201727, 47.9684563974449],
        [107.587840460869, 47.9683884986304],
        [107.587946784117, 47.9683607140757],
        [107.588052515611, 47.9683294428495],
        [107.588144702416, 47.9682974566623],
        [107.588306190978, 47.968238181447],
        [107.588387457315, 47.968205112476],
        [107.588459650393, 47.9681695173094],
        [107.588489942257, 47.96815146252],
        [107.588516822993, 47.9681329715594],
        [107.588542348451, 47.9681125983178],
        [107.588567028546, 47.9680900262338],
        [107.588614546924, 47.9680376200402],
        [107.588660289141, 47.9679752925258],
        [107.588715837566, 47.9678872470988],
        [107.588752524509, 47.9678196351681],
        [107.588785035001, 47.9677436820253],
        [107.588814295344, 47.9676578291455],
        [107.588846569314, 47.9675437294596],
        [107.588858003294, 47.9674871171368],
        [107.588876112942, 47.9673459271729],
        [107.588884926298, 47.967307250929],
        [107.588896420533, 47.9672729876583],
        [107.588928724181, 47.967190732966],
        [107.588952274728, 47.9671431129643],
        [107.588980410018, 47.9671028683028],
        [107.588996129268, 47.9670862236504],
        [107.589013131851, 47.9670716906061],
        [107.58903637303, 47.9670560657848],
        [107.589063923761, 47.9670414275199],
        [107.589095916244, 47.9670277011675],
        [107.589132633764, 47.9670147635206],
        [107.589218775326, 47.9669913604629],
        [107.589345866618, 47.966964851147],
        [107.589432808577, 47.966951438658],
        [107.589532177368, 47.9669433753365],
        [107.589639997088, 47.9669401692535],
        [107.589830594007, 47.9669397249884],
        [107.589930354003, 47.9669415515115],
        [107.590181118264, 47.9669550080672],
        [107.590296343002, 47.9669575972154],
        [107.590475398021, 47.9669562824065],
        [107.590596808296, 47.9669523577651],
        [107.59070553813, 47.9669443915704],
        [107.590802174781, 47.9669319899194],
        [107.590899526392, 47.9669126769785],
        [107.591005439549, 47.9668844895276],
        [107.591112377035, 47.9668505994756],
        [107.591322728461, 47.9667783362512],
        [107.591472647245, 47.9667244938404],
        [107.591635347194, 47.9666588298411],
        [107.591787032246, 47.9665927305701],
        [107.592139995464, 47.9664335163937],
        [107.592315935232, 47.9663585794849],
        [107.592415258158, 47.9663156953131],
        [107.592633777227, 47.9662150782633],
        [107.592729957022, 47.966174337176],
        [107.592790343799, 47.9661514710136],
        [107.592847823968, 47.9661321535761],
        [107.592903558552, 47.9661159981549],
        [107.592958142005, 47.966102837476],
        [107.593104216187, 47.9660714655258],
        [107.593197881477, 47.9660559153482],
        [107.593241755802, 47.9660512199879],
        [107.593282601211, 47.9660488934417],
        [107.593320933015, 47.9660489033343],
        [107.593357017412, 47.9660512541621],
        [107.593411000118, 47.9660594856568],
        [107.593470290621, 47.9660739548492],
        [107.593533813335, 47.9660939063088],
        [107.593635648966, 47.9661301004239],
        [107.593745795232, 47.9661708684908],
        [107.593830727206, 47.966206736152],
        [107.593901766453, 47.9662424985925],
        [107.593960044321, 47.966278864478],
        [107.593989049255, 47.9663013691129],
        [107.594016278928, 47.9663267174041],
        [107.594042026518, 47.9663551764503],
        [107.594066806438, 47.966387309227],
        [107.594103112968, 47.9664433405878],
        [107.594175395078, 47.9665724976227],
        [107.59420996232, 47.9666279759004],
        [107.594290625212, 47.9667512981339],
        [107.594374726213, 47.9668896408443],
        [107.594455083336, 47.9670293046587],
        [107.59466303627, 47.9674004611624],
        [107.594787336966, 47.9676082522191],
        [107.594968712236, 47.9679122410571],
        [107.595036473455, 47.9680203512582],
        [107.595117674141, 47.968136673169],
        [107.595158142734, 47.9681886836608],
        [107.595199221967, 47.9682375060561],
        [107.5952925653, 47.9683372138913],
        [107.595403937342, 47.9684435632199],
        [107.59553376707, 47.9685576530133],
        [107.595730651149, 47.9687221534047],
        [107.595794968863, 47.9687789428939],
        [107.595943613307, 47.9689196148484],
        [107.59602187501, 47.9689854668059],
        [107.596069870928, 47.9690200241549],
        [107.596117377615, 47.9690493654359],
        [107.596165316876, 47.96907405992],
        [107.596214188734, 47.9690943585179],
        [107.59628495009, 47.9691190314183],
        [107.596352486478, 47.9691399316626],
        [107.596416270894, 47.9691568982723],
        [107.596476008361, 47.9691698530063],
        [107.59653137962, 47.9691787365095],
        [107.596622711169, 47.9691945465911],
        [107.596666667333, 47.9691944440684],
        [107.596714304422, 47.9691829525313],
        [107.596792796351, 47.9691395089812],
        [107.596835440403, 47.9691141597907],
        [107.596873995239, 47.9690871135795],
        [107.596915750761, 47.9690541750102],
        [107.597071740868, 47.9689188630152],
        [107.597128542049, 47.9688697150654],
        [107.597183439364, 47.9688160570155],
        [107.597236965214, 47.9687573753526],
        [107.597290080073, 47.9686926223667],
        [107.597336427534, 47.9686308785123],
        [107.597385534115, 47.9685606900239],
        [107.59756811088, 47.9682832554679],
        [107.597731281174, 47.9680536648448],
        [107.59780172417, 47.9679459899156],
        [107.597834051201, 47.9678898020728],
        [107.597860908554, 47.9678367285822],
        [107.597882784563, 47.9677857990754],
        [107.597899888769, 47.96773651263],
        [107.597914983889, 47.9676819318757],
        [107.597927340574, 47.9676265741072],
        [107.597936885979, 47.9675707603823],
        [107.597943566143, 47.9675148063633],
        [107.597947344195, 47.9674590430005],
        [107.597948203047, 47.9674037490838],
        [107.597946136405, 47.9673492070004],
        [107.59794115596, 47.9672956766542],
        [107.597927764155, 47.9672274199095],
        [107.597903082261, 47.9671522608682],
        [107.597872116805, 47.9670791226035],
        [107.597784804325, 47.9668925150776],
        [107.597763020047, 47.9668382985487],
        [107.597746702748, 47.9667892243433],
        [107.597709904289, 47.9666503825092],
        [107.597678673532, 47.9665038640621],
        [107.597652746077, 47.966348454018],
        [107.597631698344, 47.9661816405703],
        [107.597624922852, 47.9661042134388],
        [107.597620954144, 47.9660231593414],
        [107.597619742757, 47.9659376122311],
        [107.59762126441, 47.9658458463088],
        [107.597629538173, 47.9656781713106],
        [107.597656534921, 47.9653001071143],
        [107.597663491177, 47.9651308322222],
        [107.597661980316, 47.9649592964344],
        [107.597643002822, 47.9645651172864],
        [107.59763980933, 47.9643889652786],
        [107.597642358908, 47.9642927135379],
        [107.597648501277, 47.9642031869276],
        [107.597658360545, 47.9641185778101],
        [107.597672046428, 47.9640379787697],
        [107.597689484282, 47.9639585119758],
        [107.597710861167, 47.9638761205866],
        [107.597736334464, 47.9637901885664],
        [107.597766222533, 47.9636996412255],
        [107.597838500147, 47.9635054964815],
        [107.597948785808, 47.9632370533474],
        [107.598050160986, 47.9629969973136],
        [107.598123785784, 47.9628358648833],
        [107.598198067987, 47.9626914022864],
        [107.598274128149, 47.9625627407779],
        [107.598317036602, 47.9624987755981],
        [107.598365484879, 47.9624330639348],
        [107.5984199775, 47.9623649259007],
        [107.598481564872, 47.962293035895],
        [107.598602458936, 47.9621616836149],
        [107.598906713974, 47.9618460674421],
        [107.59898582014, 47.9617590571348],
        [107.599053782806, 47.961679476127],
        [107.599364044415, 47.9613169540142],
        [107.599486763204, 47.9611655099803],
        [107.599548240859, 47.9610828730762],
        [107.599601773903, 47.9610046608365],
        [107.599648381268, 47.9609293767893],
        [107.599688535997, 47.9608562484172],
        [107.5997584403, 47.9607099161298],
        [107.599815862012, 47.9605679815272],
        [107.599839861321, 47.9604987400249],
        [107.599860707606, 47.9604306811311],
        [107.599878392774, 47.9603638255302],
        [107.599892915925, 47.9602981930072],
        [107.599905792418, 47.9602240430052],
        [107.599915326131, 47.9601477742005],
        [107.599921519762, 47.960069386593],
        [107.599924373311, 47.9599888684915],
        [107.599923885879, 47.9599062234935],
        [107.599920061062, 47.9598214192231],
        [107.599912895264, 47.9597344340969],
        [107.599902384887, 47.9596452204506],
        [107.59988493714, 47.9595293805765],
        [107.59986517274, 47.9594240843541],
        [107.599842477448, 47.959326088828],
        [107.599816560786, 47.9592341943027],
        [107.599786971292, 47.9591469681581],
        [107.599753687383, 47.9590645021251],
        [107.599716555275, 47.9589864130925],
        [107.599675457157, 47.958912460042],
        [107.599644806463, 47.9588641529584],
        [107.599609894781, 47.9588144555228],
        [107.59957041904, 47.9587629207722],
        [107.599525747016, 47.958708728525],
        [107.599426556291, 47.9585978834856],
        [107.599248897019, 47.9584112660671],
        [107.599134833306, 47.9582953416568],
        [107.599002882077, 47.9581696964744],
        [107.598856448167, 47.9580367478977],
        [107.598606345806, 47.9578156279889],
        [107.598488431196, 47.9577128264858],
        [107.598362920013, 47.9576065023382],
        [107.598082357615, 47.9573776158843],
        [107.597850202125, 47.9571944554598],
        [107.597265499803, 47.9567414354689],
        [107.596999787011, 47.9565322819393],
        [107.596910604841, 47.9564628713645],
        [107.596810357412, 47.9563881862658],
        [107.596307618402, 47.9560314413979],
        [107.596188398876, 47.9559434454337],
        [107.596084806868, 47.9558631746458],
        [107.59596983484, 47.9557678510056],
        [107.595868808599, 47.9556762010958],
        [107.595779682187, 47.95558636332],
        [107.595701511316, 47.9554973700077],
        [107.595634561286, 47.9554130100025],
        [107.595570390161, 47.9553264169806],
        [107.595509309107, 47.9552380118249],
        [107.595451639182, 47.955148260384],
        [107.595420873375, 47.9550940204727],
        [107.595391199344, 47.955032273021],
        [107.595307474261, 47.9548248291026],
        [107.59527388728, 47.9547495792298],
        [107.595235014984, 47.9546776235735],
        [107.595192539104, 47.9546148841696],
        [107.595109152166, 47.9545027225227],
        [107.595058373745, 47.9544425183076],
        [107.595031207025, 47.9544150323279],
        [107.595003828964, 47.9543908027933],
        [107.594975815981, 47.9543694573846],
        [107.594946936052, 47.9543508189352],
        [107.594915087461, 47.9543337641919],
        [107.594879218002, 47.9543178102188],
        [107.594838998521, 47.9543028068291],
        [107.594793723951, 47.9542884896222],
        [107.594700839272, 47.9542644255628],
        [107.594496720148, 47.9542190934365],
        [107.594366689871, 47.9541916191479],
        [107.594123168749, 47.9541487403721],
        [107.594027535742, 47.9541303654241],
        [107.593819690726, 47.954094414126],
        [107.593753282088, 47.9540812579437],
        [107.593681110595, 47.9540623263153],
        [107.593621654616, 47.9540402047917],
        [107.593590214317, 47.9540249432965],
        [107.593558974567, 47.954007195176],
        [107.593495901515, 47.9539635330906],
        [107.59343326913, 47.9539108858787],
        [107.593335991263, 47.953819612785],
        [107.593280313336, 47.9537620462814],
        [107.593226229907, 47.9536945863362],
        [107.59317886801, 47.9536264294163],
        [107.593065277341, 47.9534510885969],
        [107.593030166009, 47.9534020701495],
        [107.592996065516, 47.9533590088113],
        [107.592935873892, 47.9532907673551],
        [107.592864209616, 47.9532163331673],
        [107.592628187941, 47.9529893209005],
        [107.59255304059, 47.9529147095462],
        [107.592491964932, 47.9528500761701],
        [107.592439467907, 47.952789776627],
        [107.592372311933, 47.9527065443716],
        [107.592306581384, 47.9526203929168],
        [107.592242205214, 47.9525312314312],
        [107.592179090792, 47.9524389304124],
        [107.592117182362, 47.9523434098206],
        [107.592056302756, 47.9522444052552],
        [107.591996299989, 47.9521416712012],
        [107.591936964519, 47.9520348434333],
        [107.591894423889, 47.9519498637952],
        [107.591853002914, 47.9518536345376],
        [107.591817539948, 47.9517610853059],
        [107.591738249421, 47.9515418188999],
        [107.591695412014, 47.9514342051245],
        [107.591649923405, 47.9513355719791],
        [107.591601850145, 47.9512477477854],
        [107.591531974621, 47.9511324834774],
        [107.591478462261, 47.9510500543166],
        [107.591426124416, 47.9509770626413],
        [107.591373836034, 47.9509123258432],
        [107.591312697423, 47.9508468345139],
        [107.591237650797, 47.9507764625637],
        [107.591166741952, 47.9507154417643],
        [107.590953804974, 47.9505386683249],
        [107.590728169569, 47.9503482611633],
        [107.590644947207, 47.9502760222207],
        [107.590443265245, 47.9501029324044],
        [107.590361024042, 47.9500282985672],
        [107.59028355824, 47.9499487256532],
        [107.590251563059, 47.9499109963954],
        [107.590223509607, 47.949874010877],
        [107.59018910874, 47.9498223807983],
        [107.590155542444, 47.9497651218629],
        [107.590121955464, 47.9497009030743],
        [107.590084156958, 47.9496217294593],
        [107.59003723573, 47.9495086478059],
        [107.589996739258, 47.9493860243456],
        [107.589961985857, 47.9492519345292],
        [107.589931344156, 47.9491001325651],
        [107.58991672118, 47.9490011423888],
        [107.58990748784, 47.9488977770109],
        [107.589903577588, 47.9487893349599],
        [107.58990494186, 47.9486745805675],
        [107.589911298268, 47.948555924916],
        [107.589922788006, 47.9484263398038],
        [107.589939495611, 47.9482831011842],
        [107.589965422167, 47.9480918450627],
        [107.589990269535, 47.9479411555599],
        [107.590023455418, 47.9477847005036],
        [107.59006525231, 47.9476211623868],
        [107.590116273547, 47.9474481283285],
        [107.59017329776, 47.9472744503557],
        [107.590241527525, 47.9470826240639],
        [107.590317720786, 47.9468799555456],
        [107.590457110307, 47.9465198031464],
        [107.590527341963, 47.9463506676493],
        [107.590713155388, 47.9459371602718],
        [107.590759730377, 47.9458219894933],
        [107.590797170953, 47.9457174639898],
        [107.59087090277, 47.9454920093488],
        [107.590891218455, 47.9454154203854],
        [107.590905324321, 47.9453460718638],
        [107.590916394076, 47.9452501052082],
        [107.590919019197, 47.9451424662519],
        [107.590915223159, 47.9450414732854],
        [107.59089806949, 47.9447786185385],
        [107.590887042003, 47.9446354033013],
        [107.590852959497, 47.9443610183464],
        [107.590841771031, 47.944248841411],
        [107.590836327435, 47.944132323448],
        [107.590839404015, 47.9440278510046],
        [107.590850920733, 47.9439177506038],
        [107.590870167125, 47.9437975535143],
        [107.590897306865, 47.9436647101583],
        [107.590939048898, 47.9434863665027],
        [107.590989150129, 47.9432957264167],
        [107.591048553948, 47.943101208454],
        [107.59111729183, 47.942902715488],
        [107.59119541054, 47.9427001054256],
        [107.591250070434, 47.9425700229882],
        [107.591309564185, 47.9424380258942],
        [107.59137396104, 47.9423039603595],
        [107.591443359024, 47.942167624936],
        [107.59151782199, 47.9420288865239],
        [107.591597553185, 47.9418873566163],
        [107.591682747761, 47.9417426871753],
        [107.591773698897, 47.9415943853726],
        [107.592000217436, 47.9412270860612],
        [107.592070091162, 47.9411200055839],
        [107.592135715591, 47.9410253150663],
        [107.592207155936, 47.9409295912277],
        [107.592278515341, 47.9408419190194],
        [107.592350967423, 47.9407608586268],
        [107.592425174982, 47.9406856753037],
        [107.592509927091, 47.9406091402996],
        [107.592605336167, 47.9405324479142],
        [107.592712415745, 47.9404547752677],
        [107.592833336789, 47.9403745404528],
        [107.592941676317, 47.9403073655925],
        [107.593065896974, 47.9402340411681],
        [107.593589416618, 47.9399371659675],
        [107.593695202072, 47.9398740884185],
        [107.593789541854, 47.939815248475],
        [107.593957840082, 47.9397104810539],
        [107.594330474172, 47.9394858088231],
        [107.594476815453, 47.9393942929124],
        [107.594568138909, 47.9393345410563],
        [107.594651297419, 47.939277595085],
        [107.594727974516, 47.9392222957724],
        [107.594798989482, 47.9391680522639],
        [107.594921808994, 47.9390665691669],
        [107.595051823083, 47.9389497148575],
        [107.59517645383, 47.9388307174637],
        [107.595444671235, 47.938566913932],
        [107.595545540994, 47.9384714571921],
        [107.595803092439, 47.9382339992997],
        [107.595935600348, 47.9381049852569],
        [107.596004946171, 47.9380322328013],
        [107.596066120755, 47.9379632008411],
        [107.596120317499, 47.9378965439903],
        [107.596168086788, 47.9378315697712],
        [107.596217978477, 47.9377546912261],
        [107.596264423964, 47.9376725453517],
        [107.596307916078, 47.9375842795909],
        [107.596349309173, 47.9374881645472],
        [107.596380870881, 47.9374060771288],
        [107.596413161039, 47.9373142302676],
        [107.596521492473, 47.9369760303196],
        [107.596568850772, 47.9368386345953],
        [107.596607801309, 47.9367272526607],
        [107.596647745597, 47.9366027055504],
        [107.596772197379, 47.9361792264901],
        [107.596822175403, 47.9360182586358],
        [107.596877838941, 47.9358575479875],
        [107.596934846966, 47.9357140377727],
        [107.596983229592, 47.9356049464112],
        [107.597037017145, 47.9354917586378],
        [107.597096715941, 47.9353733934674],
        [107.597163360201, 47.9352478049423],
        [107.597305859578, 47.9349939443151],
        [107.597579222903, 47.9345263795888],
        [107.597660984767, 47.9343900459639],
        [107.597881247622, 47.9340359702838],
        [107.597942838591, 47.9339309699384],
        [107.597995094598, 47.9338358243639],
        [107.598027732794, 47.933777413397],
        [107.598110858929, 47.933637443813],
        [107.598148794132, 47.9335660916019],
        [107.598167229334, 47.9335252111197],
        [107.598181621185, 47.93348683435],
        [107.598192256567, 47.933450207661],
        [107.598199236206, 47.9334149506395],
        [107.598203127572, 47.9333790577973],
        [107.598204347952, 47.933341346526],
        [107.598198793739, 47.9332591880611],
        [107.598183091576, 47.9331677449955],
        [107.598152166589, 47.9330376041022],
        [107.598139283801, 47.932992523786],
        [107.598122645444, 47.9329460009573],
        [107.598102094136, 47.9328975985454],
        [107.598077289036, 47.9328465062613],
        [107.598021146159, 47.9327456949579],
        [107.597901620863, 47.9325513532624],
        [107.597854473905, 47.9324705806528],
        [107.597810511446, 47.9323855470554],
        [107.597777751842, 47.9323081747825],
        [107.597740846363, 47.9322041394096],
        [107.597708136222, 47.9321024836428],
        [107.597679579149, 47.9320030617919],
        [107.597655144569, 47.9319057749316],
        [107.597634806401, 47.9318105124452],
        [107.597618559249, 47.9317172419572],
        [107.59760639412, 47.9316259149041],
        [107.597598308315, 47.9315364935144],
        [107.597594352198, 47.9314563855038],
        [107.597593323373, 47.931374707277],
        [107.597595225439, 47.9312914966054],
        [107.597600054799, 47.931206798455],
        [107.59760781325, 47.9311206541949],
        [107.5976184918, 47.9310331303747],
        [107.597632084153, 47.9309442908464],
        [107.597648578619, 47.9308542129516],
        [107.597662249213, 47.9307927577796],
        [107.59767944515, 47.9307288438611],
        [107.597725333957, 47.9305903464673],
        [107.597776948747, 47.9304584725805],
        [107.597910203093, 47.9301407439003],
        [107.597943342212, 47.9300545996401],
        [107.597970586274, 47.9299765771574],
        [107.598014019032, 47.9298375059961],
        [107.598058196429, 47.9296817119415],
        [107.598226395732, 47.9290353727843],
        [107.598265602576, 47.9289001264397],
        [107.598304599877, 47.9287770164462],
        [107.598363068401, 47.9286130538494],
        [107.598511845945, 47.9282264829659],
        [107.598547593996, 47.9281249845805],
        [107.598576975747, 47.9280329461636],
        [107.598609890034, 47.9279122670375],
        [107.598637735743, 47.9277860552823],
        [107.59866075479, 47.9276532469998],
        [107.598679283522, 47.927511912245],
        [107.598693041351, 47.9273674964129],
        [107.598703625472, 47.927207364928],
        [107.598727033026, 47.9265775598066],
        [107.598734658378, 47.9264355334731],
        [107.598744148024, 47.9263083333629],
        [107.598759216165, 47.9261622771674],
        [107.598778279094, 47.9260263851097],
        [107.598801720823, 47.9258979664181],
        [107.598829792261, 47.9257756685124],
        [107.598870489282, 47.9256254673415],
        [107.598920411548, 47.9254586431019],
        [107.599096462832, 47.9249182009143],
        [107.599256915374, 47.9244287826622],
        [107.599410694948, 47.9239764020894],
        [107.599561541832, 47.9235500721782],
        [107.599711287946, 47.9231446569004],
        [107.599949812434, 47.9225182611089],
        [107.600126677604, 47.9220740364876],
        [107.600212673476, 47.9218681214167],
        [107.600296867107, 47.9216738588615],
        [107.600380361964, 47.921488707338],
        [107.600463811856, 47.9213112279309],
        [107.600622470251, 47.9209887184546],
        [107.600785744866, 47.9206720968398],
        [107.600953642896, 47.9203613513953],
        [107.601126167938, 47.9200564722284],
        [107.601303326288, 47.9197574503461],
        [107.601485117944, 47.9194642866476],
        [107.601671542907, 47.9191769775355],
        [107.601862602077, 47.91889552301],
        [107.602021445733, 47.9186711277704],
        [107.602188800573, 47.9184432656443],
        [107.602364993949, 47.9182114869706],
        [107.602550475524, 47.9179752017942],
        [107.602745511496, 47.9177340557821],
        [107.602951118999, 47.9174867763937],
        [107.603168240522, 47.9172322241878],
        [107.603398387825, 47.9169686292989],
        [107.60380467005, 47.9165052311316],
        [107.603992443097, 47.9162938742629],
        [107.604184654298, 47.9160832890126],
        [107.604361961036, 47.9158961994501],
        [107.604547035218, 47.9157097735872],
        [107.604727378965, 47.9155377935344],
        [107.604905871908, 47.915377518158],
        [107.605084117538, 47.9152275166367],
        [107.60536785814, 47.914997039282],
        [107.605552108543, 47.914854760239],
        [107.605642136975, 47.9147893669358],
        [107.60572903127, 47.9147293884505],
        [107.605814099041, 47.9146739209647],
        [107.605898065144, 47.9146224968308],
        [107.606106054051, 47.914502806959],
        [107.606197204837, 47.9144534746482],
        [107.606283928261, 47.9144088781672],
        [107.60636874782, 47.9143677692572],
        [107.606451309181, 47.9143303718492],
        [107.60653222838, 47.9142964071535],
        [107.606611893024, 47.9142657132921],
        [107.606718488767, 47.9142279174845],
        [107.606823724735, 47.9141934140948],
        [107.60692739948, 47.9141622687737],
        [107.607029361016, 47.9141345282859],
        [107.607129443869, 47.9141102340001],
        [107.60722757789, 47.9140894030036],
        [107.60732367135, 47.9140720550813],
        [107.607417649605, 47.9140582019245],
        [107.607525681565, 47.9140460493857],
        [107.607637467295, 47.9140372378283],
        [107.607752396156, 47.9140318176143],
        [107.607869738797, 47.9140298202201],
        [107.607988828821, 47.9140312654306],
        [107.608108618518, 47.9140361460513],
        [107.608228132123, 47.9140444216128],
        [107.608346301241, 47.9140560192699],
        [107.608439024941, 47.9140684955646],
        [107.608534970013, 47.9140853668463],
        [107.608635102328, 47.91410679859],
        [107.608741309564, 47.9141331918934],
        [107.608834638508, 47.9141589439801],
        [107.608937977806, 47.9141895955734],
        [107.609277016821, 47.9142967461979],
        [107.609401662856, 47.9143347569435],
        [107.609687663455, 47.9144218284047],
        [107.609978166959, 47.9145156420832],
        [107.61027374174, 47.9146163814409],
        [107.61057519359, 47.9147243234688],
        [107.610676468045, 47.9147643693802],
        [107.610888411271, 47.9148568502635],
        [107.610981907489, 47.9148950669538],
        [107.61108343825, 47.9149307493547],
        [107.61113124621, 47.914944799463],
        [107.611177924622, 47.9149565787831],
        [107.611311094432, 47.9149844361829],
        [107.611435600173, 47.9150044820712],
        [107.611551785387, 47.915016771307],
        [107.611606758245, 47.9150200061684],
        [107.611659643778, 47.9150213002928],
        [107.611729198244, 47.9150197876331],
        [107.61180184458, 47.9150143899022],
        [107.611877964996, 47.915005081919],
        [107.61195826726, 47.9149917773487],
        [107.612041233316, 47.9149748709935],
        [107.612131103468, 47.9149536272082],
        [107.612229583728, 47.9149277321292],
        [107.612356746966, 47.9148919094341],
        [107.61248158186, 47.9148555525418],
        [107.61257587038, 47.9148263272733],
        [107.612659338258, 47.9147981200373],
        [107.612733344368, 47.9147703786501],
        [107.612801504886, 47.9147416093379],
        [107.61286231974, 47.9147122851439],
        [107.612916326727, 47.9146821470635],
        [107.612963796542, 47.9146510413125],
        [107.613010571181, 47.9146139029094],
        [107.613054154126, 47.9145715916058],
        [107.613094906904, 47.9145237611627],
        [107.613133450948, 47.914469687626],
        [107.613166876051, 47.914414845169],
        [107.613200565554, 47.9143517766133],
        [107.613303546022, 47.9141324472547],
        [107.61335014979, 47.9140249018278],
        [107.613392077982, 47.9139029429665],
        [107.613426298985, 47.9137818933198],
        [107.613497017174, 47.9135036592665],
        [107.613530605953, 47.9133679200935],
        [107.613559572217, 47.9132254126227],
        [107.613584230728, 47.9130746304899],
        [107.613605076113, 47.9129125663619],
        [107.613619408609, 47.9127717918847],
        [107.613632329169, 47.9126145840958],
        [107.613678298015, 47.9119247168522],
        [107.613694217814, 47.9117529571333],
        [107.613712628735, 47.9115978168858],
        [107.613734598273, 47.9114511995133],
        [107.61376025683, 47.9113130483585],
        [107.61378995874, 47.9111814811405],
        [107.613823945019, 47.9110554465516],
        [107.613838955603, 47.9109968332373],
        [107.61386793086, 47.9108617217911],
        [107.613884647459, 47.9108007531523],
        [107.613911444558, 47.9107324622334],
        [107.613927445295, 47.9107023025692],
        [107.613945448823, 47.9106742644058],
        [107.613980840743, 47.9106297929306],
        [107.61402678261, 47.9105821720296],
        [107.614078738243, 47.9105347148053],
        [107.614187012121, 47.9104417132145],
        [107.614239509146, 47.9103972768129],
        [107.614296591814, 47.9103520301222],
        [107.614427603251, 47.9102566965893],
        [107.614538261232, 47.9101820510609],
        [107.614821053049, 47.9099989562869],
        [107.614948370071, 47.909913508102],
        [107.61562824225, 47.9094439181024],
        [107.616134983243, 47.9090860652698],
        [107.616268021752, 47.9089953011922],
        [107.616389571422, 47.9089157039966],
        [107.616700799802, 47.908719060936],
        [107.616940068929, 47.9085753438771],
        [107.617053376312, 47.9085108849694],
        [107.617162692504, 47.9084513390581],
        [107.617269269361, 47.9083960253563],
        [107.617373847925, 47.9083445589543],
        [107.617603058135, 47.9082374829735],
        [107.617795959116, 47.9081536175954],
        [107.617975398146, 47.9080830450965],
        [107.618061410206, 47.9080522586049],
        [107.618145635313, 47.9080242222401],
        [107.618300942834, 47.9079780762273],
        [107.618474275468, 47.9079333664318],
        [107.618669581236, 47.9078888940573],
        [107.618924091174, 47.907836173101],
        [107.619065350386, 47.9078101925864],
        [107.619222614832, 47.9077860799637],
        [107.61939655091, 47.9077634080549],
        [107.619907855064, 47.9077024520066],
        [107.620067617826, 47.9076795714551],
        [107.620209446309, 47.907655466027],
        [107.620489890896, 47.9076071499501],
        [107.620605224452, 47.9075851012715],
        [107.620721777488, 47.9075578913836],
        [107.620822102258, 47.9075279520534],
        [107.620895169477, 47.9075019013917],
        [107.620967073871, 47.9074736069215],
        [107.621037212897, 47.9074433060638],
        [107.621105038867, 47.9074112371389],
        [107.621169987905, 47.9073776699436],
        [107.621231676001, 47.9073428059258],
        [107.621289703857, 47.9073068708155],
        [107.621343745917, 47.9072700678594],
        [107.621408763304, 47.9072212625513],
        [107.621469706762, 47.9071708312689],
        [107.621525765102, 47.9071194494031],
        [107.621576383443, 47.9070676304668],
        [107.621621005105, 47.907015963516],
        [107.621659484398, 47.906964650898],
        [107.62169159649, 47.9069139902885],
        [107.621717205585, 47.9068642020214],
        [107.621731901406, 47.9068267893249],
        [107.621743267938, 47.9067867667959],
        [107.621751418493, 47.9067437630143],
        [107.621756493368, 47.9066970270462],
        [107.621758420615, 47.9066033059978],
        [107.621750498487, 47.9064093438162],
        [107.62174563945, 47.9062807164819],
        [107.62173543844, 47.9061600814227],
        [107.621719765954, 47.9060459313747],
        [107.621698514975, 47.9059375145047],
        [107.621667706899, 47.9058181618787],
        [107.621629826555, 47.9056995457975],
        [107.621585178813, 47.9055826114484],
        [107.621534104515, 47.9054682518584],
        [107.621496574008, 47.9053959625536],
        [107.621452393014, 47.9053215814259],
        [107.621401103778, 47.9052443305615],
        [107.621341697262, 47.9051626829116],
        [107.621228848533, 47.905021008213],
        [107.620995164196, 47.9047461978788],
        [107.620900890064, 47.9046312852057],
        [107.620691123197, 47.9043738164985],
        [107.620449443887, 47.9040897053757],
        [107.620217333363, 47.9038246940544],
        [107.619615961208, 47.9031469685578],
        [107.619471583147, 47.9029861868631],
        [107.619307857971, 47.9028109818414],
        [107.619123468174, 47.9026195107819],
        [107.618576698356, 47.9020599858797],
        [107.618408274223, 47.9018820640061],
        [107.618261313309, 47.9017212220568],
        [107.61809731384, 47.9015326279285],
        [107.617952045451, 47.901354111603],
        [107.617822572754, 47.9011820614031],
        [107.617707526082, 47.9010146364164],
        [107.617590148367, 47.9008264038155],
        [107.617468631073, 47.9006143283886],
        [107.617351289331, 47.900396015264],
        [107.61711920129, 47.8999495756125],
        [107.616948009043, 47.8996348749496],
        [107.616886943278, 47.899518807547],
        [107.616825087008, 47.8993915148066],
        [107.616775743906, 47.8992762612905],
        [107.616719698156, 47.8991272049566],
        [107.61667352876, 47.8989883766123],
        [107.616636277942, 47.8988568732461],
        [107.616607590468, 47.8987313953377],
        [107.616589711946, 47.8986326075089],
        [107.616575504456, 47.898533931196],
        [107.616564998576, 47.8984356038201],
        [107.616558219486, 47.8983378466144],
        [107.616555179778, 47.8982408871073],
        [107.616555884846, 47.8981448979687],
        [107.616560335591, 47.8980500590631],
        [107.61656852122, 47.8979565367648],
        [107.616581538008, 47.897851987879],
        [107.616597464102, 47.8977520399247],
        [107.616616365153, 47.8976562648248],
        [107.616638291524, 47.8975644260574],
        [107.616663309764, 47.8974762565241],
        [107.61669143696, 47.8973917274463],
        [107.616722704589, 47.8973107452947],
        [107.616757134234, 47.897233248016],
        [107.616780813384, 47.8971865543161],
        [107.616807587101, 47.8971395944168],
        [107.616870681737, 47.8970444290572],
        [107.616947081842, 47.8969467321061],
        [107.617038328856, 47.8968445205582],
        [107.617123265326, 47.8967580075761],
        [107.617223085577, 47.8966628575049],
        [107.61755597233, 47.8963636000002],
        [107.617668519786, 47.8962595898083],
        [107.617767570217, 47.8961626132141],
        [107.617852148758, 47.8960730290471],
        [107.617957928815, 47.8959591173195],
        [107.618210820873, 47.895695747261],
        [107.61832794318, 47.8955670578734],
        [107.618392469537, 47.8954908502226],
        [107.618449286006, 47.8954186994135],
        [107.618499523934, 47.895349161135],
        [107.618543712123, 47.8952815015401],
        [107.618640177003, 47.895118814182],
        [107.618677703913, 47.8950494269895],
        [107.618710130768, 47.8949843268653],
        [107.618738461211, 47.8949213680268],
        [107.618762439835, 47.8948609398805],
        [107.618782263591, 47.8948025540947],
        [107.618798026907, 47.8947459165908],
        [107.618821525293, 47.8946334185974],
        [107.618835230961, 47.8945263821868],
        [107.618839140314, 47.8944248433319],
        [107.618833251553, 47.8943288568913],
        [107.618821653896, 47.8942627252446],
        [107.618801118777, 47.8941892866063],
        [107.618699868604, 47.8939156444915],
        [107.618670383431, 47.8938182128403],
        [107.618611020083, 47.8936026381513],
        [107.6185836708, 47.8935139164341],
        [107.61854433895, 47.8934077433727],
        [107.618500752408, 47.8933147255942],
        [107.618465472903, 47.8932521084981],
        [107.618424698541, 47.8931876999524],
        [107.618378066894, 47.8931209225926],
        [107.618324828828, 47.893050697232],
        [107.618205817045, 47.8929073749754],
        [107.617989675783, 47.8926641605227],
        [107.61788785634, 47.892551784837],
        [107.61777937292, 47.8924377022382],
        [107.617663881083, 47.8923215413062],
        [107.617540852928, 47.8922027750381],
        [107.617410182334, 47.8920812694351],
        [107.617270297286, 47.8919555343205],
        [107.61711978495, 47.8918242944557],
        [107.616955661375, 47.891684948102],
        [107.616859726195, 47.8916067097819],
        [107.61675690131, 47.8915272294981],
        [107.616646387221, 47.8914458849197],
        [107.61652673602, 47.8913616076521],
        [107.616395148118, 47.8912724488645],
        [107.616247321157, 47.8911755208337],
        [107.615637443213, 47.8907886900461],
        [107.615376411392, 47.8906176821604],
        [107.615237453546, 47.8905221534746],
        [107.615110918034, 47.8904311474795],
        [107.614994281361, 47.8903428430478],
        [107.614886308756, 47.8902563039853],
        [107.614708965147, 47.8901074850724],
        [107.614542512327, 47.8899631124078],
        [107.614385934064, 47.8898223064543],
        [107.614238623314, 47.889684519525],
        [107.614117722055, 47.8895669619458],
        [107.613998783117, 47.8894471137933],
        [107.613881832581, 47.8893250002486],
        [107.613766897424, 47.88920065009],
        [107.613654001031, 47.8890740893977],
        [107.613543178475, 47.8889453550441],
        [107.613434455836, 47.8888144785054],
        [107.613327866388, 47.8886814993518],
        [107.613223415528, 47.8885464229791],
        [107.613121159914, 47.8884093240312],
        [107.613021136416, 47.8882702465747],
        [107.612923377412, 47.8881292382738],
        [107.612827915276, 47.8879863449939],
        [107.612734791378, 47.8878416287882],
        [107.61264404079, 47.8876951472133],
        [107.612555704882, 47.8875469632218],
        [107.612502498292, 47.8874593548654],
        [107.61235706083, 47.8872294962443],
        [107.612282816399, 47.8870997312676],
        [107.612247863348, 47.8870288008386],
        [107.612219774823, 47.8869620261766],
        [107.612198025618, 47.8868981329425],
        [107.612182396301, 47.8868364745238],
        [107.612173306853, 47.8867850171149],
        [107.61216691627, 47.8867310910671],
        [107.612163180486, 47.8866743303561],
        [107.612162056334, 47.8866140937654],
        [107.612167277798, 47.8864833683128],
        [107.612183868491, 47.8863066596247],
        [107.612190880505, 47.8862554171538],
        [107.612201752409, 47.8861983659619],
        [107.612258291887, 47.8859568386372],
        [107.612267805815, 47.8859011849917],
        [107.612273433772, 47.8858505225836],
        [107.612276281026, 47.8857856580817],
        [107.61227501478, 47.8857178015353],
        [107.612269626942, 47.885646225393],
        [107.612260009592, 47.8855694799476],
        [107.61223499405, 47.8854294653976],
        [107.612168065604, 47.8851177540811],
        [107.612145403588, 47.8849830833027],
        [107.612131465894, 47.8848613636611],
        [107.612108156366, 47.8845890039794],
        [107.612095301457, 47.8844684273761],
        [107.612075964234, 47.8843413711574],
        [107.61205117802, 47.884228398322],
        [107.612029372158, 47.8841498956012],
        [107.612003959115, 47.8840691032066],
        [107.611941743117, 47.8838989002141],
        [107.611863240396, 47.8837139105686],
        [107.61176123839, 47.8834970885198],
        [107.611623776116, 47.8832034814556],
        [107.611584514414, 47.8831259715864],
        [107.611546716808, 47.8830575484671],
        [107.611503000763, 47.8829863536373],
        [107.611457916849, 47.8829213803175],
        [107.611410677261, 47.8828614953618],
        [107.611360826941, 47.8828061339959],
        [107.611307944106, 47.8827533222081],
        [107.611251785042, 47.8827012910318],
        [107.611192642926, 47.8826503165589],
        [107.611130827126, 47.8826006568948],
        [107.611066664995, 47.8825525818362],
        [107.611000466798, 47.8825063198109],
        [107.61093255899, 47.8824620983472],
        [107.610863251838, 47.8824201197927],
        [107.610733936522, 47.8823476398318],
        [107.610618209063, 47.882289458192],
        [107.610508289426, 47.8822416763124],
        [107.610454916461, 47.8822214496602],
        [107.610402331303, 47.8822035585474],
        [107.6103504683, 47.8821888168605],
        [107.610291496156, 47.8821756220074],
        [107.61022263057, 47.8821632923022],
        [107.610012391559, 47.8821301549827],
        [107.609947317515, 47.8821166534608],
        [107.609890923727, 47.8821016671583],
        [107.609785914389, 47.8820674884239],
        [107.609682951007, 47.8820288562468],
        [107.609583518365, 47.8819863300052],
        [107.609489048181, 47.8819405194395],
        [107.609357142818, 47.8818692067985],
        [107.609303477574, 47.8818371936316],
        [107.609255599466, 47.8818062092892],
        [107.609212258439, 47.8817753931199],
        [107.609173772851, 47.8817449061026],
        [107.609139903484, 47.8817145602788],
        [107.609110521733, 47.881684236938],
        [107.609089471302, 47.8816588373855],
        [107.609069847196, 47.881631231796],
        [107.609034032595, 47.8815681596429],
        [107.609003995238, 47.881499653786],
        [107.608953904799, 47.8813661449317],
        [107.608930535916, 47.8812982721976],
        [107.608912265289, 47.8812267356254],
        [107.608898910357, 47.8811508310461],
        [107.608890226503, 47.8810692049799],
        [107.608886353123, 47.880994008167],
        [107.608885514055, 47.8809100906282],
        [107.608894313022, 47.8806085533421],
        [107.608894372377, 47.8804871655503],
        [107.608886664288, 47.8803626328293],
        [107.608879413954, 47.8803058361455],
        [107.60886978851, 47.8802517329312],
        [107.608859724197, 47.8801941088711],
        [107.608839661221, 47.880051997102],
        [107.608824825106, 47.8799794478933],
        [107.608813192375, 47.8799394865181],
        [107.608799441741, 47.8799029803383],
        [107.608783308803, 47.879869223386],
        [107.608764619092, 47.8798378685229],
        [107.608717221223, 47.8797752802051],
        [107.608656774191, 47.8797109840747],
        [107.608583613443, 47.8796453416592],
        [107.608498485417, 47.8795790283495],
        [107.608452977023, 47.8795483497766],
        [107.60840189643, 47.8795188196379],
        [107.608344700448, 47.8794901168754],
        [107.60828024154, 47.8794616623259],
        [107.608156002897, 47.8794140764985],
        [107.607858206791, 47.8793107246103],
        [107.607786026304, 47.8792829364584],
        [107.607722878608, 47.8792560845008],
        [107.607431138536, 47.879131714557],
        [107.607320945505, 47.8790818174719],
        [107.60726230701, 47.8790527360949],
        [107.607209487128, 47.8790242491698],
        [107.607161459734, 47.8789958045128],
        [107.607117736494, 47.8789671026497],
        [107.607016301061, 47.8788923276189],
        [107.606928072173, 47.8788178412704],
        [107.606889136025, 47.8787808953221],
        [107.606853708132, 47.8787442029827],
        [107.606821829864, 47.8787078056208],
        [107.606793530897, 47.8786717365115],
        [107.606766338995, 47.8786319882757],
        [107.606741440365, 47.8785895043022],
        [107.606718746873, 47.878544133505],
        [107.606698129016, 47.878495613282],
        [107.606679610176, 47.8784441333901],
        [107.6066627308, 47.8783885462944],
        [107.606632197018, 47.8782591446439],
        [107.60662321459, 47.8782071764201],
        [107.606616944516, 47.8781531469502],
        [107.606613361617, 47.8780968718732],
        [107.606612450604, 47.8780380643053],
        [107.6066185579, 47.8779119460795],
        [107.606635625234, 47.8777671273511],
        [107.606647917168, 47.8776919323369],
        [107.606662799149, 47.8776182382911],
        [107.6066802415, 47.8775461963],
        [107.606700212745, 47.8774759295705],
        [107.606722676011, 47.8774075649072],
        [107.606747607916, 47.8773411688599],
        [107.606774977883, 47.8772768214682],
        [107.606804760731, 47.8772145820873],
        [107.606844151936, 47.877142235226],
        [107.606889718786, 47.8770685555695],
        [107.606941585386, 47.8769933380722],
        [107.606999970272, 47.8769162679715],
        [107.607064837472, 47.8768373389721],
        [107.607136988281, 47.8767555339408],
        [107.607217162842, 47.8766700039176],
        [107.607307202066, 47.8765787820852],
        [107.607386945851, 47.876503293892],
        [107.607480019387, 47.876421805422],
        [107.60758288834, 47.8763366935836],
        [107.607765785263, 47.8761899449101],
        [107.607827632539, 47.8761425263565],
        [107.608016418223, 47.876005207974],
        [107.608071994527, 47.8759597499426],
        [107.60811768908, 47.875917056427],
        [107.608194027133, 47.8758388118118],
        [107.60824174606, 47.8757841438232],
        [107.608278181193, 47.8757332341015],
        [107.608302941328, 47.8756857966623],
        [107.608315033612, 47.8756525325384],
        [107.608324298428, 47.8756177350705],
        [107.608330631454, 47.8755818071547],
        [107.608333949053, 47.8755452020495],
        [107.608334209856, 47.8755083811069],
        [107.60833140577, 47.8754718623366],
        [107.608325575465, 47.875436135869],
        [107.608316795384, 47.8754016693516],
        [107.60830511409, 47.8753687640573],
        [107.608289873279, 47.8753352571165],
        [107.608271206951, 47.8753014498021],
        [107.608249311157, 47.8752676955478],
        [107.608224388245, 47.8752343181093],
        [107.60819677726, 47.8752017824364],
        [107.608166833433, 47.8751705058143],
        [107.60813496056, 47.8751409118237],
        [107.608101742302, 47.8751134582196],
        [107.608065632723, 47.8750866907982],
        [107.608027122854, 47.875060973785],
        [107.607986720811, 47.8750366471236],
        [107.60794500216, 47.8750140516572],
        [107.607902412067, 47.8749934230081],
        [107.607859427171, 47.8749749941007],
        [107.607816468355, 47.8749589439002],
        [107.607779490931, 47.8749475521879],
        [107.607739279544, 47.8749378574962],
        [107.607695405219, 47.8749297492086],
        [107.607646980324, 47.8749230654471],
        [107.607569358039, 47.8749157467644],
        [107.607369199529, 47.8749036355944],
        [107.607278944468, 47.8748954760454],
        [107.606464299888, 47.8747944794817],
        [107.606194425033, 47.8747625175762],
        [107.605886770558, 47.8747301078083],
        [107.605610195754, 47.8747063333307],
        [107.605352779207, 47.8746895303976],
        [107.605065499773, 47.8746755432418],
        [107.60478101813, 47.8746650085833],
        [107.604144729796, 47.8746449977685],
        [107.603971579725, 47.8746412871657],
        [107.603574946327, 47.8746400164237],
        [107.60339803619, 47.8746370054935],
        [107.603301464291, 47.874633374031],
        [107.603211715548, 47.8746282541906],
        [107.603126976928, 47.8746215398522],
        [107.603046341016, 47.8746131590701],
        [107.602798902447, 47.8745861209527],
        [107.602670220255, 47.874567967238],
        [107.602608180523, 47.8745564478219],
        [107.602551472872, 47.8745436019058],
        [107.602499153913, 47.8745292109544],
        [107.602450748803, 47.874513144566],
        [107.602391817129, 47.8744901399081],
        [107.602333105788, 47.8744641180247],
        [107.602275577056, 47.8744355024965],
        [107.602220341596, 47.8744048455073],
        [107.602173160463, 47.8743752748991],
        [107.602127060316, 47.8743424910132],
        [107.602081969208, 47.8743064407897],
        [107.602037773824, 47.8742670369942],
        [107.601994486756, 47.8742243084052],
        [107.601951723094, 47.874177898891],
        [107.601909190557, 47.8741274972862],
        [107.601866208359, 47.874072302295],
        [107.601839509286, 47.8740346350904],
        [107.601814191572, 47.8739946188566],
        [107.601767099472, 47.8739065482487],
        [107.601723742257, 47.8738062945249],
        [107.601677785102, 47.8736792392056],
        [107.601660964182, 47.8736234911312],
        [107.601647448271, 47.8735647231335],
        [107.601637085383, 47.8735023119822],
        [107.601629667775, 47.8734350076195],
        [107.601623313165, 47.8733108750969],
        [107.601619838185, 47.8730224903957],
        [107.601616027758, 47.8729507667645],
        [107.601609934851, 47.8728861055094],
        [107.601599514406, 47.8727641178698],
        [107.601585512861, 47.8724773852232],
        [107.601579111487, 47.8724050140802],
        [107.601570745993, 47.8723399769084],
        [107.601556094238, 47.872261000245],
        [107.60153699084, 47.87218826038],
        [107.601513051786, 47.8721203139014],
        [107.601484016274, 47.8720564458483],
        [107.601430431969, 47.871953082269],
        [107.601390000248, 47.8718851258979],
        [107.601347132264, 47.8718262940483],
        [107.601301282129, 47.8717767782758],
        [107.601265460333, 47.8717451293343],
        [107.601224996237, 47.8717138104441],
        [107.601180013947, 47.8716829196311],
        [107.601130697824, 47.8716525810019],
        [107.601077160283, 47.8716228763947],
        [107.601019838395, 47.8715940585191],
        [107.600959152143, 47.8715663369169],
        [107.600895728355, 47.8715400011702],
        [107.600828306181, 47.8715154307925],
        [107.600755600491, 47.8714929783184],
        [107.60067768143, 47.871472664432],
        [107.600594642529, 47.8714545152138],
        [107.600506549438, 47.8714385468515],
        [107.600413605404, 47.8714247998147],
        [107.600315999284, 47.8714133019823],
        [107.600214015265, 47.8714040866293],
        [107.600149293755, 47.871400290591],
        [107.600081210579, 47.8713986808045],
        [107.600009097542, 47.8713992428808],
        [107.599931647028, 47.8714019813164],
        [107.59978055283, 47.8714119314155],
        [107.599456550479, 47.8714401701278],
        [107.599302389594, 47.8714536905354],
        [107.599141968527, 47.8714709728072],
        [107.598973643319, 47.8714921878143],
        [107.598794197095, 47.8715177411509],
        [107.598458862387, 47.8715715251059],
        [107.597670175838, 47.8717076743697],
        [107.597438631887, 47.8717487032401],
        [107.597183761322, 47.8717995590025],
        [107.596925939181, 47.871855237829],
        [107.596231539354, 47.8720106181955],
        [107.596021195122, 47.8720548072836],
        [107.595831631525, 47.8720918521573],
        [107.595613563915, 47.8721301821622],
        [107.595408519388, 47.8721610981562],
        [107.595212477974, 47.8721852044836],
        [107.595023387419, 47.8722027421629],
        [107.594766818934, 47.8722227880513],
        [107.594616570099, 47.8722322192416],
        [107.594476392771, 47.8722371502244],
        [107.59435017562, 47.8722368876223],
        [107.59409740677, 47.8722285850812],
        [107.594000569571, 47.8722225209526],
        [107.593913007979, 47.8722146213078],
        [107.593829791911, 47.8722043033859],
        [107.593752862105, 47.87219165622],
        [107.593681444243, 47.8721765521062],
        [107.593615121041, 47.8721589002132],
        [107.593532834873, 47.8721305859579],
        [107.593444768761, 47.8720925572258],
        [107.593366846103, 47.8720539052636],
        [107.593154362384, 47.8719422652234],
        [107.593021080159, 47.871874257591],
        [107.592875534778, 47.871795935634],
        [107.592404334093, 47.8715297399056],
        [107.592229081407, 47.8714333910382],
        [107.591912325793, 47.8712675722407],
        [107.5915532265, 47.8710874119545],
        [107.591209427373, 47.8709199572902],
        [107.5904136101, 47.870537637502],
        [107.590040054205, 47.8703543547697],
        [107.58971961317, 47.8701918113031],
        [107.589431856195, 47.8700396532075],
        [107.589152160744, 47.8698870796251],
        [107.588875495108, 47.8697337551088],
        [107.588601904255, 47.8695797066382],
        [107.588331427753, 47.8694249539985],
        [107.588064106973, 47.86926952327],
        [107.587799981484, 47.869113435137],
        [107.587539081863, 47.868956710284],
        [107.587281444983, 47.8687993693954],
        [107.587027121205, 47.8686414430482],
        [107.586776120422, 47.8684829402355],
        [107.586528476808, 47.8683238789439],
        [107.586284217343, 47.8681642789584],
        [107.586043367208, 47.8680041573661],
        [107.585805953382, 47.8678435294554],
        [107.585572001047, 47.8676824141121],
        [107.585341529088, 47.8675208248263],
        [107.585111283759, 47.8673542793766],
        [107.584877004071, 47.8671775562992],
        [107.584636650361, 47.8669891231496],
        [107.58438658937, 47.8667861362712],
        [107.584141431482, 47.8665811708844],
        [107.583873938931, 47.8663521027674],
        [107.582854363138, 47.8654579239441],
        [107.58262406295, 47.8652585946085],
        [107.582415310518, 47.865080899364],
        [107.582172255245, 47.8648786184535],
        [107.581941443343, 47.8646920073303],
        [107.581718317946, 47.8645173904653],
        [107.581500532723, 47.8643529359393],
        [107.581248708161, 47.8641684687998],
        [107.58096462132, 47.8639644468018],
        [107.579955674615, 47.8632524382495],
        [107.579344493554, 47.8628103234377],
        [107.579176860824, 47.8626939556616],
        [107.579023172082, 47.8625922549287],
        [107.578818017837, 47.8624612902564],
        [107.5786429666, 47.8623521080634],
        [107.578480849412, 47.8622540118133],
        [107.578327745229, 47.8621646677653],
        [107.578177990122, 47.8620808608431],
        [107.578032567949, 47.8620032430553],
        [107.577890154907, 47.8619311048367],
        [107.577749929016, 47.8618640360964],
        [107.577594848124, 47.8617940940223],
        [107.577429603993, 47.8617234459803],
        [107.577252674072, 47.8616514381634],
        [107.577060901739, 47.8615767809437],
        [107.576998058014, 47.8615539516536],
        [107.576926754366, 47.8615302383299],
        [107.576656981135, 47.8614482048708],
        [107.576547561521, 47.8614124253432],
        [107.576437957546, 47.8613707984236],
        [107.576389964325, 47.861349662557],
        [107.576345670916, 47.8613279529227],
        [107.576292189133, 47.8612987393454],
        [107.57623840248, 47.8612663448659],
        [107.576183810035, 47.8612304736075],
        [107.576127488193, 47.861190519427],
        [107.576017636904, 47.8611054552526],
        [107.575820479432, 47.860942409065],
        [107.575782892267, 47.8609101701683],
        [107.575743269936, 47.8608730200739],
        [107.575604080964, 47.8607305602672],
        [107.57554425896, 47.8606735225651],
        [107.575476390723, 47.8606179345701],
        [107.575442689529, 47.860594382225],
        [107.575408567451, 47.8605732400631],
        [107.575362649866, 47.8605481831522],
        [107.575312268047, 47.8605237719545],
        [107.575256999311, 47.8604998005254],
        [107.57519600729, 47.860475901042],
        [107.575063690037, 47.8604301336438],
        [107.574835648946, 47.8603590494307],
        [107.57475143643, 47.8603342281422],
        [107.574661993456, 47.8603109860632],
        [107.574566448583, 47.860289092068],
        [107.574463107487, 47.8602681576494],
        [107.574259850812, 47.8602328772456],
        [107.573872064944, 47.8601741038519],
        [107.573716178259, 47.8601487960302],
        [107.573557014445, 47.8601191858518],
        [107.573416480087, 47.8600881565433],
        [107.573245043224, 47.8600457562067],
        [107.573078826926, 47.860002576158],
        [107.572917602765, 47.8599585543438],
        [107.572761196272, 47.8599136431002],
        [107.572455817982, 47.8598217054075],
        [107.572217181078, 47.8597444968111],
        [107.572006120086, 47.8596693314745],
        [107.571909386309, 47.8596319007917],
        [107.571817598803, 47.8595942245938],
        [107.571742073738, 47.8595611313412],
        [107.571664603439, 47.8595249435214],
        [107.571499703748, 47.8594413290542],
        [107.571347870308, 47.8593583342198],
        [107.571022702436, 47.8591743311305],
        [107.570893681198, 47.8591040679984],
        [107.570764665357, 47.8590338453358],
        [107.570439533458, 47.858850092258],
        [107.570287708111, 47.8587671495844],
        [107.570122803025, 47.8586834469836],
        [107.569969779782, 47.858613906007],
        [107.56972901778, 47.858509954271],
        [107.569593457572, 47.8584562746374],
        [107.569526031801, 47.8584326305615],
        [107.569461897549, 47.8584125639887],
        [107.569400005306, 47.858395751163],
        [107.569339806487, 47.858382045495],
        [107.569279319885, 47.8583710980478],
        [107.569214878064, 47.8583622442222],
        [107.569145827218, 47.858355390489],
        [107.569070848041, 47.8583504019496],
        [107.568931355098, 47.8583459008427],
        [107.568578765098, 47.8583423224403],
        [107.568473544419, 47.8583405660643],
        [107.568356103751, 47.8583409024108],
        [107.567975657251, 47.8583488209414],
        [107.567840282303, 47.8583503848624],
        [107.567711373481, 47.858349378521],
        [107.567594929263, 47.858345421504],
        [107.567260774465, 47.8583311438672],
        [107.567166967981, 47.8583254592526],
        [107.56708365119, 47.8583186999481],
        [107.56699782439, 47.8583094279378],
        [107.566918689446, 47.8582981936068],
        [107.566844922555, 47.8582848071982],
        [107.56677585732, 47.8582691428068],
        [107.566715170169, 47.8582528264068],
        [107.5666534461, 47.8582341654744],
        [107.566526836844, 47.8581897974213],
        [107.566395893756, 47.8581359972785],
        [107.566260097925, 47.8580725519068],
        [107.566199671578, 47.858041382304],
        [107.566138882803, 47.8580073654476],
        [107.566077449215, 47.8579703439563],
        [107.566014922051, 47.8579300489326],
        [107.565885477233, 47.8578390438369],
        [107.565736877755, 47.8577247597899],
        [107.565603134177, 47.8576140829237],
        [107.565485435405, 47.8575069278025],
        [107.565382607821, 47.8574022242333],
        [107.56533661829, 47.8573506328255],
        [107.565294181981, 47.8572994811861],
        [107.565240840492, 47.8572309123767],
        [107.565194178269, 47.8571671414505],
        [107.565152999212, 47.8571065334398],
        [107.565116869848, 47.8570484363363],
        [107.565085328825, 47.8569920623338],
        [107.565058422908, 47.8569374402107],
        [107.565036038782, 47.8568843451364],
        [107.56501811979, 47.8568326341188],
        [107.565005399779, 47.8567853297792],
        [107.564995586377, 47.856735546908],
        [107.564988609437, 47.8566829671453],
        [107.564984392516, 47.8566270185221],
        [107.564983862815, 47.8565051585862],
        [107.564993867773, 47.8563412364589],
        [107.565009213804, 47.8562005312296],
        [107.565033454131, 47.856064516864],
        [107.56506647274, 47.8559338255856],
        [107.565108159014, 47.8558088998609],
        [107.56512796928, 47.8557632511731],
        [107.565154778071, 47.8557131391501],
        [107.565258505875, 47.8555488590926],
        [107.565293890601, 47.8554873382701],
        [107.565322216547, 47.8554255152754],
        [107.565339436766, 47.855368552217],
        [107.565361124816, 47.8552806731646],
        [107.565368126938, 47.8552367781548],
        [107.565367372406, 47.8551953715692],
        [107.565363503523, 47.8551770415872],
        [107.565357256832, 47.8551600255148],
        [107.565335841276, 47.8551221721506],
        [107.565307105239, 47.8550857990704],
        [107.565273938242, 47.8550545206497],
        [107.56523840243, 47.8550302380551],
        [107.565218497736, 47.8550205883295],
        [107.565195561426, 47.8550123613315],
        [107.565169369571, 47.8550054743232],
        [107.565139441932, 47.8549998005004],
        [107.565081816972, 47.8549928451437],
        [107.564926711798, 47.8549804434927],
        [107.564719770601, 47.8549579883206],
        [107.564639480028, 47.8549515923422],
        [107.564566122329, 47.8549476668014],
        [107.564495528246, 47.8549460947865],
        [107.564429229326, 47.8549470264841],
        [107.564366533988, 47.8549504708876],
        [107.564307060922, 47.8549564522785],
        [107.5642436821, 47.8549663178413],
        [107.564173724738, 47.8549809633009],
        [107.563945734908, 47.8550402106372],
        [107.563811095606, 47.855075524316],
        [107.563666328139, 47.8551162249339],
        [107.56350767424, 47.855163307141],
        [107.563308254972, 47.8552247398299],
        [107.563122692458, 47.8552865025701],
        [107.562693677172, 47.8554400959837],
        [107.562581655819, 47.8554770590191],
        [107.56247886151, 47.8555081575755],
        [107.562178873756, 47.8555929339668],
        [107.561965686767, 47.8556472170455],
        [107.561865469916, 47.8556696443387],
        [107.561770101309, 47.8556886470135],
        [107.561678361467, 47.8557044669876],
        [107.561589566905, 47.8557172211729],
        [107.561480740844, 47.8557302748323],
        [107.561377000448, 47.8557407924037],
        [107.561277525537, 47.8557488548258],
        [107.561181897027, 47.8557544971724],
        [107.561089637377, 47.8557577401277],
        [107.561000714212, 47.8557585791951],
        [107.560914966552, 47.8557570152741],
        [107.560832292776, 47.8557530465659],
        [107.560757183197, 47.8557473079919],
        [107.56068074532, 47.8557395810169],
        [107.560524815468, 47.8557182634871],
        [107.560366592344, 47.8556893763637],
        [107.560208911512, 47.8556534331595],
        [107.560117898322, 47.8556287530645],
        [107.560025189911, 47.8555999675645],
        [107.559930526373, 47.8555669930224],
        [107.559833478732, 47.8555296846473],
        [107.559734173793, 47.8554881233782],
        [107.559631019756, 47.8554416769919],
        [107.559522757569, 47.8553897888078],
        [107.559405870884, 47.8553307761944],
        [107.559346228746, 47.8552987900072],
        [107.559287215233, 47.8552647083996],
        [107.559228698146, 47.8552284549293],
        [107.559170520103, 47.8551899324694],
        [107.559054535439, 47.8551056605978],
        [107.558936919403, 47.8550101948646],
        [107.558849941472, 47.8549335672304],
        [107.558757358965, 47.8548471531736],
        [107.558656183436, 47.8547483500564],
        [107.558359503388, 47.8544520099524],
        [107.558262749826, 47.8543601055345],
        [107.558173425563, 47.8542797789887],
        [107.55724112178, 47.8534695248987],
        [107.556961607992, 47.8532224586496],
        [107.556713732353, 47.8529992828907],
        [107.556464090445, 47.8527691859492],
        [107.556234021383, 47.8525509888371],
        [107.556019700349, 47.8523410564946],
        [107.555819142539, 47.8521374391915],
        [107.555709609611, 47.8520314019277],
        [107.555444079381, 47.8517923810136],
        [107.555384834742, 47.8517352344935],
        [107.555334293743, 47.8516829416145],
        [107.555276223619, 47.8516161255838],
        [107.555229357249, 47.8515529302236],
        [107.555192766533, 47.8514921000804],
        [107.55516608095, 47.8514329948369],
        [107.555144115908, 47.8513659000163],
        [107.5551280756, 47.85129809653],
        [107.555117960925, 47.8512295834785],
        [107.555113770984, 47.8511603599627],
        [107.555115505776, 47.8510904277811],
        [107.555123168, 47.851019787833],
        [107.555136754058, 47.8509484383198],
        [107.55515626485, 47.8508763783423],
        [107.555181701275, 47.8508036105982],
        [107.555213062433, 47.8507301332891],
        [107.555250350124, 47.8506559464149],
        [107.555293562548, 47.8505810508748],
        [107.555342697907, 47.8505054457698],
        [107.555397759799, 47.8504291319989],
        [107.555458747323, 47.8503521095623],
        [107.555527778384, 47.8502777778972],
        [107.560305556256, 47.8353611116261],
        [107.539388889386, 47.7846388895732],
        [107.538194444918, 47.7457500000625],
        [107.483892424696, 47.7208063894034],
        [107.483527778384, 47.7206388888737],
        [107.476666666134, 47.650666665834],
        [107.410638889373, 47.6464999997752],
        [107.330138889498, 47.6519444441808],
        [107.29700000075, 47.648111110939],
        [107.294861110752, 47.6687222223528],
        [107.26605555492, 47.6888055549325],
        [107.216638889473, 47.7252222225276],
        [107.227416667046, 47.761305555507],
        [107.225355348071, 47.7667145207586],
        [107.220250000237, 47.7801111115386],
        [107.223167574524, 47.7889535004037],
        [107.2319999998, 47.8157222222029],
        [107.25753145861, 47.8100363224184],
        [107.292444444456, 47.8022500002374],
        [107.318138888299, 47.8597499997627],
        [107.363527777185, 47.8791944440684],
        [107.371916666721, 47.9019722219405],
        [107.384249999838, 47.9136388894233],
        [107.411194443769, 47.9432500003873],
        [107.365250000487, 47.9626944455923],
        [107.372472222915, 47.9903055560566],
        [107.445527776985, 47.9962222218781],
        [107.455500000325, 48.0006666669332],
        [107.455571419985, 48.00060599597],
        [107.455639789145, 48.0005457773658],
        [107.455705079026, 48.0004845524202],
        [107.455767293226, 48.0004223220326],
        [107.455826431744, 48.0003590862029],
        [107.455882492783, 48.0002948458305],
        [107.455935479039, 48.0002296000161],
        [107.455985387815, 48.0001633478603],
        [107.456019196928, 48.0001144706064],
        [107.45605193315, 48.0000626174959],
        [107.45611561954, 47.9999476589574],
        [107.456175448738, 47.9998227431252],
        [107.45627234889, 47.9996020189181],
        [107.456350488284, 47.9994209188404],
        [107.456410535118, 47.9992694496254],
        [107.456459180347, 47.999130690529],
        [107.456497522942, 47.9990012142347],
        [107.456529054972, 47.9988735123028],
        [107.456554166741, 47.9987512809469],
        [107.456573020129, 47.9986337305623],
        [107.456585684382, 47.9985204105885],
        [107.456592700892, 47.9983768967764],
        [107.456589911196, 47.9982219552791],
        [107.456577363854, 47.9980520013988],
        [107.456553867267, 47.9978506063205],
        [107.45653237347, 47.9977124119983],
        [107.456502798366, 47.9975629815464],
        [107.456464507931, 47.9973984766584],
        [107.456411674559, 47.9971938062492],
        [107.45636483337, 47.9970339742385],
        [107.456304719088, 47.996857588407],
        [107.456239456186, 47.9966836514294],
        [107.456062750196, 47.9962321414002],
        [107.456014104068, 47.9960992090113],
        [107.455973447517, 47.9959792799199],
        [107.455861822765, 47.9956364700471],
        [107.45582997957, 47.9955276592741],
        [107.455804635775, 47.9954294748904],
        [107.455762708482, 47.9952535899812],
        [107.455740300974, 47.9951445417872],
        [107.455725300282, 47.995043742175],
        [107.455718562562, 47.9949523980348],
        [107.455719104853, 47.9948635468153],
        [107.455726103377, 47.9947668867824],
        [107.45573959051, 47.9946600392295],
        [107.455761728221, 47.994525770448],
        [107.45579192116, 47.9943678423022],
        [107.455822164461, 47.9942406071184],
        [107.455856657059, 47.9941264750568],
        [107.4558963981, 47.9940226860981],
        [107.455935917009, 47.9939373782075],
        [107.455982804963, 47.9938486043297],
        [107.456037481944, 47.9937555559742],
        [107.456100983973, 47.9936564605772],
        [107.456177849928, 47.9935436325327],
        [107.456242742309, 47.9934557435877],
        [107.456306229049, 47.9933784981192],
        [107.456369933426, 47.9933101415498],
        [107.456428126757, 47.9932548188548],
        [107.456492321264, 47.9931995222402],
        [107.456562615872, 47.9931441590757],
        [107.456639189547, 47.9930885944631],
        [107.456722044986, 47.9930328041207],
        [107.456811761354, 47.9929763860514],
        [107.456908859356, 47.9929190084056],
        [107.457014471241, 47.9928600020875],
        [107.457088417996, 47.9928212206229],
        [107.457167489988, 47.9927826370091],
        [107.457252220514, 47.9927439913422],
        [107.457343561956, 47.9927048456521],
        [107.457545832974, 47.9926248518555],
        [107.457822942875, 47.9925234164226],
        [107.457941867423, 47.9924825017661],
        [107.458068295915, 47.9924425691693],
        [107.458203577333, 47.9924031869576],
        [107.458350438422, 47.9923635601302],
        [107.458622183867, 47.992296251271],
        [107.459240390432, 47.9921521502016],
        [107.459514331122, 47.9920827729017],
        [107.459761045736, 47.9920184345032],
        [107.460338049861, 47.9918727416337],
        [107.460614107555, 47.9917993884311],
        [107.460773483609, 47.9917542478603],
        [107.460920681045, 47.9917100219],
        [107.461058646939, 47.9916658238188],
        [107.461188839094, 47.9916211814724],
        [107.461450352951, 47.9915262193596],
        [107.461665250451, 47.9914431480829],
        [107.461856614491, 47.9913630301797],
        [107.462028940783, 47.991283888041],
        [107.462238710348, 47.9911810469678],
        [107.462308803509, 47.9911428473646],
        [107.462369290111, 47.9911063061112],
        [107.462449256028, 47.9910523126142],
        [107.462524861133, 47.9909955923728],
        [107.462595223191, 47.9909368063886],
        [107.462659591267, 47.9908765832877],
        [107.462708693352, 47.9908240044243],
        [107.462757914146, 47.9907635385065],
        [107.462806888527, 47.9906964481826],
        [107.462883498175, 47.9905844295279],
        [107.462954144418, 47.9904763903731],
        [107.463021509035, 47.9903632862367],
        [107.463085686455, 47.9902449570392],
        [107.463146818771, 47.9901211464738],
        [107.463189201121, 47.9900235709311],
        [107.463230197616, 47.9899133464239],
        [107.46326477385, 47.9898085394326],
        [107.46333701729, 47.9895758983091],
        [107.463369851537, 47.9894778029583],
        [107.463473712442, 47.9891646626191],
        [107.463505461208, 47.9890805301424],
        [107.463537628159, 47.9890059259827],
        [107.463588933582, 47.9888971880549],
        [107.463629856333, 47.9888173840151],
        [107.463670701742, 47.9887464194118],
        [107.463712492338, 47.9886828940004],
        [107.463766360829, 47.9886044686214],
        [107.46379627318, 47.9885648354988],
        [107.463828709028, 47.9885286593702],
        [107.463862260935, 47.9884987551135],
        [107.463920388615, 47.9884579402818],
        [107.463985963581, 47.9884208513413],
        [107.464055367861, 47.9883895270551],
        [107.46412542325, 47.9883653955466],
        [107.464157075788, 47.9883573232319],
        [107.464191366938, 47.9883507545837],
        [107.464269539608, 47.9883418270138],
        [107.464348543251, 47.9883381991486],
        [107.464536185896, 47.9883352925398],
      ],
    ],
  },
};
